export default {
  ranking: [
    {
      "title": "小熊优恩",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bear.jpg.webp",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "高清",
      "license": "（闽）动审字[2015]第019号",
      "lang": "中文",
      "region": "大陆",
      "actor": "骆妍倩 / 陈旭昇 / 乐嘉晔 / 吕佩玉 / 刘以嘉 / 王愫酥",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "一心照顾调皮孩子的“新爸爸”-阿憨；专注工作、同时也爱着孩子的“新妈妈”-莉莉；还有他们聪明顽皮，状况不断的宝贝儿子-“优恩”——他们一起为我们带来了一个关于新生家庭的奇妙故事。 没有人教过阿憨怎么养大孩子从而笑料百出的优恩。寓教于乐，这是一部超级奶爸的成长史，也是一部欢乐育儿的教科书，给大家带来快乐的感受。",
      "video": "bear"
    },
    {
      "title": "卫浴也疯狂",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bath.jpg.webp",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（苏）动审字[2015]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": " 洗脸台 /  水龙头 /  抽水马桶 /  花洒",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "平淡无趣的卫生间里迎来了一群疯狂可爱的新伙伴，他们是洗脸台、水龙头、抽水马桶、花洒以及淋浴房。在这个看似普通的卫浴间里，每当主人不在或是夜幕降临的时候，这里就会呈现出另一番景象。 生活在这里的卫浴们被赋予了生命，面对麻烦制造者 “病菌拉吉”和沙皮狗“乌眼青”的破坏行动，卫浴们与捣蛋分子斗智斗勇，在嬉笑怒骂中打赢了一次又一次的家园保卫战",
      "video": "bath"
    },
    {
      "title": "功夫家族之笨笨鼠",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mouse.jpg.webp",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（闽）动审字[2013]第050号",
      "lang": "中文",
      "region": "大陆",
      "actor": "笨笨鼠 / 反斗熊 / 爱心兔 / 一米熊",
      "classify": "益智",
      "years": "2013",
      "director": "李竹兵",
      "intro": "功夫村里住着笨笨鼠、反斗熊、爱心兔、一米熊四个好朋友。笨笨鼠是个大智若愚的乐天派，不管世界怎样，即使把事情搞砸也能自得其乐。反斗熊是个有着大力气但头脑简单的家伙，笨笨鼠最“亲密”的朋友，只要有笨笨鼠的地方总会有他的身影，两人在一起总能闹出一些让人发笑的故事，当然最后常常是看似弱小的笨笨鼠获得胜利。爱心兔是个爱幻想爱撒娇喜欢一切粉红事物的小女生，也是笨笨鼠和反斗熊抢着帮助的对象。一米熊是只不够自信又渴望强大的小熊，思维简单但心地善良，但也常常好心办坏事。四个性格不同的朋友在一起看似打打闹闹，但其实谁也离不开谁，内心里都把彼此当做不可缺的朋友，为紧张和压力下的现代观众带来了一幕幕源于生活的欢乐故事",
      "video": "mouse"
    },
    {
      "title": "卡西龙之寻龙记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dragons.jpg.webp",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2012]第018号",
      "lang": "中文",
      "region": "大陆",
      "actor": "阿尔 / 小玮 / 琳达 / 金金 / 威威 / 西西",
      "classify": "科幻",
      "years": "2012",
      "director": "李竹兵",
      "intro": "太阳系中有一个神秘的龙族，是维护宇宙正义的战族，他们在最危急的时刻会出现在需要的星系，而战龙的养成绝非偶然，必须组成团队家族，而按各属性安排在不同的行星诞生成长感受正义与力量",
      "video": "dragon"
    },
    {
      "title": "石头娃",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/stone.jpg.webp",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "13",
      "totalDuration": "338",
      "mediaType": "高清",
      "license": "（苏）动审字[2018]第009号",
      "lang": "中文",
      "region": "大陆",
      "actor": "地客 /  憨憨 /  雨雨 /  花花",
      "classify": "冒险",
      "years": "2019",
      "director": "张瑶",
      "intro": "以南京雨花石为动漫造型，讲述了神奇的雨花石精灵带着一个机智可爱的小学生雨雨穿越时光旅行，展现一个神奇的科幻世界：史前动植物的消失，能源的危机， 海啸、 火山的形成，大裂谷的跋涉和冰川的消融等等，雨雨最终破译“智慧之门”的密码",
      "video": "stone"
    },
    // {
    //   "title": "嘟嘟镇",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/countries.jpeg",
    //   "country": "中国",
    //   "type": "益智",
    //   "setNum": "52",
    //   "duration": "13",
    //   "totalDuration": "676",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字【2016】035号",
    //   "lang": "",
    //   "region": "",
    //   "actor": "顾烨",
    //   "classify": "亲子、教育",
    //   "years": "2016",
    //   "director": "应勋",
    //   "intro": "故事讲述了刚到嘟嘟镇工作的快递员阿卡，突然被卷入一场盗窃案中，被误会成小偷，上演了一场闹剧。后来误会化解，阿卡也在这场事件中渐渐熟悉了小镇上每位成员，他也靠着勤奋、热心与诚实获得了大家的认可。之后，整个小镇围绕着阿卡上演起一幕幕或幽默、或紧张、或温情的小故事，通过剧情传达爱与关怀的人文精神，教育小朋友友爱互助，关心社会与环境，拥抱梦想并热爱生活",
    //   "video": "cities"
    // },
    {
      "title": "百越历险记之壮锦密码",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/heros.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "12",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "（桂）动审字[2017]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "刘三姐 / 小昭 / 猴小白 / 卡索 / 呱呱国师",
      "classify": "其他",
      "years": "2017",
      "director": "卢军",
      "intro": "万年前，祖洛神和天仙灵珊与魔王决战于米洛仙山岜赤山顶，最终大败魔王并用12圣器将魔界与人间的通道封印，天仙灵珊舍身取义壮烈牺牲。为防万年后“七星连珠”之际魔界再次为祸人间，祖洛神留下12圣器分藏于百越大地，并派米洛王族世代镇守岜赤山。天仙灵珊在封印魔界时功力耗尽，万年之后转世人间，只有她才能运用十二圣器，用她的歌声把铜鼓等12圣器组合成天音法阵，才能彻底封印魔王，而这个人就是米洛王的三公主婉馨，她在壮王的指引下，解开了壮锦的秘密，按照壮锦地图的指引完成任务。",
      "video": "code"
    },
    {
      "title": "铜鼓奇缘",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/drum.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "14",
      "duration": "11",
      "totalDuration": "154",
      "mediaType": "高清",
      "license": "（桂）动审字[2019]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "刘婉馨 / 唐筱米 / 猴小白 / 武石甲 / 穆莱尔 / 高拉·索朗弓",
      "classify": "神话",
      "years": "2019",
      "director": "李尚玻",
      "intro": "塞壬来源自古老的希腊神话传说，在神话中的她被塑造成一名人面鸟身的海妖，飞翔在大海上，拥有天籁般的歌喉，常用歌声诱惑过路的航海者而使航船触礁沉没，船员则成为塞壬的腹中餐。别有用心的塞壬高科技公司，受传说的海上女妖故事启发，开展魔音计划，在东南亚的无人岛上建设了TEM高频声波传输发射塔，从世界各地选出歌声与魔音高度匹配的歌手，用高科技系统把歌手魔化，再利用发射塔把魔音声波发射到海上丝绸之路航线上，欲以此手段控制船员实现海盗计划。 ",
      "video": "drum"
    },
    {
      "title": "瓷都传奇之牛牛和妞妞",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/legend.jpeg",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "12",
      "totalDuration": "312",
      "mediaType": "高清",
      "license": "（闽）动审字[2016]第008号",
      "lang": "中文",
      "region": "大陆",
      "actor": "王亚琳 / 叶方 / 王辛 / 唐泽宗 / 王雪沁 / 丁妍",
      "classify": "神话",
      "years": "2017",
      "director": "徐辉",
      "intro": "牛牛和妞妞来到瓷都德化，遇到正苦恼于改进瓷窑的窑神林炳。受牛牛和妞妞的启发，林炳成功建成龙窑，提高了瓷器的产量。大盗烮震在远洋大船海南一号建成之际，偷走了龙窑里的凌火瓷珠，瓷器的生产受阻。经过努力，赶走了大盗，还帮助改进制瓷工艺。",
      "video": "legend1"
    },
    {
      "title": "土楼探险之牛牛和妞妞",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/legend2.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2013]第017号",
      "lang": "中文",
      "region": "大陆",
      "actor": "付洁 /  马奇 /  张继伟 /  周正",
      "classify": "神话",
      "years": "2013",
      "director": "徐辉",
      "intro": "牛牛和妞妞与织女在鹊桥相会，淘气的妞妞失足落入人间。为了找回妹妹，牛牛在太白金星的指引下，来到永定的土楼中找到了妞妞，但牛牛发现妹妹失忆了，妹妹身上拥有守护神力祥云也不见了。邪恶的夜魔及其手下老鼠夺走了祥云。牛牛在土楼朋友们的帮助下，使妞妞恢复了记忆，并最终战胜夜魔。",
      "video": "house"
    },
    {
      "title": "哈喽！葡星人",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/star1.jpeg",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "15",
      "totalDuration": "390",
      "mediaType": "高清",
      "license": "（沪）动审字[2016]第013号",
      "lang": "中文",
      "region": "大陆",
      "actor": "塔塔 /  侯烨 /  裘莎莎 /  朱志摩",
      "classify": "益智",
      "years": "2016",
      "director": "刘思蜀",
      "intro": "外星人塔塔携宠物小Q与超越人类科技千年的高科技来到了地球。本以为能无往不利，结果一场意外，飞船报废，只好赖在地球男孩侯烨。侯烨平凡无奇的暑假彻底被颠覆，这个意外闯入的外星室友一边给他带来种种意想不到的麻烦，一边让侯烨见识到自己从未想象过的神奇科技：来自遥远光年外的葡星文明，千变万化的神秘探索器，眼前这个充满秘密的外星朋友。",
      "video": "star"
    },
    {
      "title": "哈喽！葡星人之极训特工",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/star2.jpeg",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "15",
      "totalDuration": "390",
      "mediaType": "高清",
      "license": "（沪）动审字[2018]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "塔塔 /  侯烨 /  朱志摩 /  裘莎莎",
      "classify": "益智",
      "years": "2018",
      "director": "未知",
      "intro": "关于外星学霸塔塔来地球完成毕业报告时，因飞船意外报废，结识了地球少年侯烨。从此侯烨平凡无奇的暑假彻底被颠覆，在经历了一连串鸡飞狗跳的事件后，几个孩子从相互敌对，到成为朋友；从自我中心，到学会分享；从叛逆敷衍，到承担责任",
      "video": "star2"
    },
    {
      "title": "阿古顿巴",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/history.jpeg",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "10",
      "totalDuration": "260",
      "mediaType": "高清",
      "license": "（藏）动审字【2017】第 01 号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2020",
      "director": "未知",
      "intro": "在雪域高原的山南地区有一个平凡的小村子，村里人世世代代、按部就班地过着平凡的日子，地主收租，农户种田，牧民放牧，卖杂货的走街串巷，村口还有一个小茶馆。突然有一天，不知从哪里来了一个四处流浪的人——阿古顿巴，打破了村民们平静的生活，故事就从这里开始了",
      "video": "bus1"
    },
    {
      "title": "阿古顿巴  第二季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/history2.jpeg",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "10",
      "totalDuration": "260",
      "mediaType": "高清",
      "license": "（藏）动审字【2018】第 1 号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2020",
      "director": "未知",
      "intro": "在雪域高原的山南地区有一个平凡的小村子，村里人世世代代、按部就班地过着平凡的日子，地主收租，农户种田，牧民放牧，卖杂货的走街串巷，村口还有一个小茶馆。突然有一天，不知从哪里来了一个四处流浪的人——阿古顿巴，打破了村民们平静的生活，故事就从这里开始了。",
      "video": "bus2"
    },
    {
      "title": "么么侠 第一季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/hero.jpeg",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13.5",
      "totalDuration": "175.5",
      "mediaType": "1920*1080",
      "license": "（苏）动审字【2022】第005号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "科幻",
      "years": "2020",
      "director": "未知",
      "intro": "在深邃的宇宙中，有一颗美丽的绿色星球——雷普星，在雷普星上，植被遍地，生态和谐，人们安居乐业。雷普星外，有一颗小卫星么么星，雷普星的守护者初代么么侠就住在这里，远远的守望着雷普星和上面的人们。 几百年前，来自宇宙深处的破坏者——混沌王发现了雷普星，他打算把雷普星变成生命灭绝，岩浆横流的死星。为了保护雷普星，初代么么侠和污污大王展开了一场殊死决战。",
      "video": "hero"
    },
    {
      "title": "熊猫博士",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda1.jpeg",
      "country": "中国",
      "type": "动画片",
      "setNum": "39",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "docotor"
    },
    // {
    //   "title": "熊猫博士和拖拖（二）",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda2.jpg.webp",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video2"
    // },
    // {
    //   "title": "熊猫博士和拖拖（三）",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda3.jpeg",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video3"
    // },
    // {
    //   "title": "熊猫博士和拖拖第一季英文版",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda4.jpeg",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "50",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video4"
    // },
    // {
    //   "title": "熊猫博士和拖拖第二季英文版",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda4.jpeg",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video5"
    // },
    // {
    //   "title": "熊猫博士和拖拖第三季英文版",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda5.jpeg",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video6"
    // },
    // {
    //   "title": "熊猫博士看世界：安全消防课",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda6.webp",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "3",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "科普",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video7"
    // },
    // {
    //   "title": "熊猫博士看世界：垃圾分类总动员",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda7.webp",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "2",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video8"
    // },
    // {
    //   "title": "熊猫博士看世界：汽车的小秘密",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda8.jpeg",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "1",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "科普",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video9"
    // },
    // {
    //   "title": "熊猫博士看世界：新冠肺炎全科普",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda9.jpeg",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "4",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "科普",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video10"
    // }
    {
      "title": "摩比传说",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mobi-legend.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "32",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2013",
      "director": "",
      "intro": "《摩比传说》目前已在好未来全国各个分校推广，为孩子的课间生活增加了很多乐趣，而动画片中的人物也被广泛置入好未来的课件和文具中，生动可爱的卡通形象深受孩子的喜爱",
      "video": "legend"
    }
  ],
  latest: [
    {
      "index": "1",
      "title": "小熊优恩",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bear.jpg.webp",
      "carousel": "4",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "高清",
      "license": "（闽）动审字[2015]第019号",
      "lang": "中文",
      "region": "大陆",
      "actor": "骆妍倩 / 陈旭昇 / 乐嘉晔 / 吕佩玉 / 刘以嘉 / 王愫酥",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "一心照顾调皮孩子的“新爸爸”-阿憨；专注工作、同时也爱着孩子的“新妈妈”-莉莉；还有他们聪明顽皮，状况不断的宝贝儿子-“优恩”——他们一起为我们带来了一个关于新生家庭的奇妙故事。 没有人教过阿憨怎么养大孩子从而笑料百出的优恩。寓教于乐，这是一部超级奶爸的成长史，也是一部欢乐育儿的教科书，给大家带来快乐的感受。",
      "video": "bear"
    },
    {
      "index": "2",
      "title": "卫浴也疯狂",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bath.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（苏）动审字[2015]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": " 洗脸台 /  水龙头 /  抽水马桶 /  花洒",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "平淡无趣的卫生间里迎来了一群疯狂可爱的新伙伴，他们是洗脸台、水龙头、抽水马桶、花洒以及淋浴房。在这个看似普通的卫浴间里，每当主人不在或是夜幕降临的时候，这里就会呈现出另一番景象。 生活在这里的卫浴们被赋予了生命，面对麻烦制造者 “病菌拉吉”和沙皮狗“乌眼青”的破坏行动，卫浴们与捣蛋分子斗智斗勇，在嬉笑怒骂中打赢了一次又一次的家园保卫战",
      "video": "bath"
    },
    {
      "index": "3",
      "title": "功夫家族之笨笨鼠",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mouse.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（闽）动审字[2013]第050号",
      "lang": "中文",
      "region": "大陆",
      "actor": "笨笨鼠 / 反斗熊 / 爱心兔 / 一米熊",
      "classify": "益智",
      "years": "2013",
      "director": "李竹兵",
      "intro": "功夫村里住着笨笨鼠、反斗熊、爱心兔、一米熊四个好朋友。笨笨鼠是个大智若愚的乐天派，不管世界怎样，即使把事情搞砸也能自得其乐。反斗熊是个有着大力气但头脑简单的家伙，笨笨鼠最“亲密”的朋友，只要有笨笨鼠的地方总会有他的身影，两人在一起总能闹出一些让人发笑的故事，当然最后常常是看似弱小的笨笨鼠获得胜利。爱心兔是个爱幻想爱撒娇喜欢一切粉红事物的小女生，也是笨笨鼠和反斗熊抢着帮助的对象。一米熊是只不够自信又渴望强大的小熊，思维简单但心地善良，但也常常好心办坏事。四个性格不同的朋友在一起看似打打闹闹，但其实谁也离不开谁，内心里都把彼此当做不可缺的朋友，为紧张和压力下的现代观众带来了一幕幕源于生活的欢乐故事",
      "video": "mouse"
    },
    {
      "index": "4",
      "title": "卡西龙之寻龙记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dragons.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2012]第018号",
      "lang": "中文",
      "region": "大陆",
      "actor": "阿尔 / 小玮 / 琳达 / 金金 / 威威 / 西西",
      "classify": "科幻",
      "years": "2012",
      "director": "李竹兵",
      "intro": "太阳系中有一个神秘的龙族，是维护宇宙正义的战族，他们在最危急的时刻会出现在需要的星系，而战龙的养成绝非偶然，必须组成团队家族，而按各属性安排在不同的行星诞生成长感受正义与力量",
      "video": "dragon"
    },
    {
      "index": "6",
      "title": "石头娃",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/stone.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "13",
      "totalDuration": "338",
      "mediaType": "高清",
      "license": "（苏）动审字[2018]第009号",
      "lang": "中文",
      "region": "大陆",
      "actor": "地客 /  憨憨 /  雨雨 /  花花",
      "classify": "冒险",
      "years": "2019",
      "director": "张瑶",
      "intro": "以南京雨花石为动漫造型，讲述了神奇的雨花石精灵带着一个机智可爱的小学生雨雨穿越时光旅行，展现一个神奇的科幻世界：史前动植物的消失，能源的危机， 海啸、 火山的形成，大裂谷的跋涉和冰川的消融等等，雨雨最终破译“智慧之门”的密码",
      "video": "stone"
    },
    // {
    //   "index": "8",
    //   "title": "嘟嘟镇",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/city.jpeg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "益智",
    //   "setNum": "52",
    //   "duration": "13",
    //   "totalDuration": "676",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字【2016】035号",
    //   "lang": "",
    //   "region": "",
    //   "actor": "顾烨",
    //   "classify": "亲子、教育",
    //   "years": "2016",
    //   "director": "应勋",
    //   "intro": "故事讲述了刚到嘟嘟镇工作的快递员阿卡，突然被卷入一场盗窃案中，被误会成小偷，上演了一场闹剧。后来误会化解，阿卡也在这场事件中渐渐熟悉了小镇上每位成员，他也靠着勤奋、热心与诚实获得了大家的认可。之后，整个小镇围绕着阿卡上演起一幕幕或幽默、或紧张、或温情的小故事，通过剧情传达爱与关怀的人文精神，教育小朋友友爱互助，关心社会与环境，拥抱梦想并热爱生活",
    //   "video": "cities"
    // },
    {
      "index": "9",
      "title": "百越历险记之壮锦密码",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/heros.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "12",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "（桂）动审字[2017]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "刘三姐 / 小昭 / 猴小白 / 卡索 / 呱呱国师",
      "classify": "其他",
      "years": "2017",
      "director": "卢军",
      "intro": "万年前，祖洛神和天仙灵珊与魔王决战于米洛仙山岜赤山顶，最终大败魔王并用12圣器将魔界与人间的通道封印，天仙灵珊舍身取义壮烈牺牲。为防万年后“七星连珠”之际魔界再次为祸人间，祖洛神留下12圣器分藏于百越大地，并派米洛王族世代镇守岜赤山。天仙灵珊在封印魔界时功力耗尽，万年之后转世人间，只有她才能运用十二圣器，用她的歌声把铜鼓等12圣器组合成天音法阵，才能彻底封印魔王，而这个人就是米洛王的三公主婉馨，她在壮王的指引下，解开了壮锦的秘密，按照壮锦地图的指引完成任务。",
      "video": "code"
    },
    {
      "index": "18",
      "title": "么么侠 第一季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/hero.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13.5",
      "totalDuration": "175.5",
      "mediaType": "1920*1080",
      "license": "（苏）动审字【2022】第005号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "科幻",
      "years": "2020",
      "director": "未知",
      "intro": "在深邃的宇宙中，有一颗美丽的绿色星球——雷普星，在雷普星上，植被遍地，生态和谐，人们安居乐业。雷普星外，有一颗小卫星么么星，雷普星的守护者初代么么侠就住在这里，远远的守望着雷普星和上面的人们。 几百年前，来自宇宙深处的破坏者——混沌王发现了雷普星，他打算把雷普星变成生命灭绝，岩浆横流的死星。为了保护雷普星，初代么么侠和污污大王展开了一场殊死决战。",
      "video": "hero"
    },
    {
      "index": "1",
      "title": "熊猫博士",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda1.jpeg",
      "carousel": "5",
      "country": "中国",
      "type": "动画片",
      "setNum": "39",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "docotor"
    },
    // {
    //   "index": "2",
    //   "title": "熊猫博士和拖拖（二）",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda2.jpg.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video2"
    // },
    // {
    //   "index": "3",
    //   "title": "熊猫博士和拖拖（三）",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda3.jpeg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video3"
    // },
    // {
    //   "index": "4",
    //   "title": "熊猫博士和拖拖第一季英文版",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda4.jpeg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "50",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video4"
    // }
    {
      "title": "摩比传说",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mobi-legend.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "32",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2013",
      "director": "",
      "intro": "《摩比传说》目前已在好未来全国各个分校推广，为孩子的课间生活增加了很多乐趣，而动画片中的人物也被广泛置入好未来的课件和文具中，生动可爱的卡通形象深受孩子的喜爱",
      "video": "legend"
    }
  ],
  hot: [
    {
      "index": "1",
      "title": "轰轰龙之超级汽车救援队",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dragons.jpg.webp",
      "carousel": "1",
      "country": "中国",
      "type": "动画片",
      "setNum": "20",
      "duration": "3",
      "totalDuration": "60",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220504001",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "彭颉颉",
      "intro": "《轰轰龙之超级汽车救援队》是一档集合恐龙、汽车及救援知识的儿童益智动画片。孩子们将跟随快乐勇敢的轰轰龙、聪明的啾啾龙，博学多识的龟博士一起出动，通过极富想象力的超级汽车变身，在他们生活的小城里，圆满完成救援任务。感受爱与友谊，培养孩子的同情心和正义感。",
      "video": "car"
    },
    {
      "index": "4",
      "title": "穿越云南三千年-云小志漫游记",
      "img": "https://p.ssl.qhimg.com/dmfd/224_314_75/d/dy_a73215b3910835396605f7dc95171a21.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "10",
      "duration": "13",
      "totalDuration": "130",
      "mediaType": "高清",
      "license": "（云）动审字[2020]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "历史、益智",
      "years": "未知",
      "director": "未知",
      "intro": "讲述了一个酷爱历史的小男孩—云小志，偶遇传说中的上古神兽白泽。小志发现白泽对他佩戴的祖父留下的一块古玉很感兴趣，但并不知道这块古玉真正的作用。于是小志用这块古玉诱惑白泽，带他亲眼见证各种历史人物的事迹，解答各种奇怪的问题，在过程中探究古玉的秘密。",
      "video": "yunnan1"
    },
    {
      "index": "5",
      "title": "穿越云南三千年-云小志漫游记（第二季）",
      "img": "https://p.ssl.qhimg.com/dmfd/224_314_75/d/dy_a73215b3910835396605f7dc95171a21.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "11",
      "duration": "13",
      "totalDuration": "143",
      "mediaType": "高清",
      "license": "（云）动审字[2022]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "历史、益智",
      "years": "未知",
      "director": "未知",
      "intro": "讲述了一个酷爱历史的小男孩—云小志，偶遇传说中的上古神兽白泽。小志发现白泽对他佩戴的祖父留下的一块古玉很感兴趣，但并不知道这块古玉真正的作用。于是小志用这块古玉诱惑白泽，带他亲眼见证各种历史人物的事迹，解答各种奇怪的问题，在过程中探究古玉的秘密。",
      "video": "yunnan2"
    },
    // {
    //   "index": "28",
    //   "title": "精灵爱牙讲堂之口腔健康知识",
    //   "img": "https://p.ssl.qhimg.com/dmfd/224_314_75/d/dy_466ba1f35da485b59974e40704b44e8f.jpeg.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "20",
    //   "duration": "4",
    //   "totalDuration": "80",
    //   "mediaType": "高清",
    //   "license": "（鄂）动审字[2015]第003号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "牙牙精灵",
    //   "classify": "科普",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "影片以人的牙齿为原型，设计主角牙牙精灵。通过讲述牙牙精灵跟随武大口腔医院牙博士接诊患者、参加口腔知识社区等故事，向广大观众宣传专业的口腔健康知识，以此提醒广大消费者增强口腔健康保护意识。",
    //   "video": "Health"
    // },
    {
      "index": "1",
      "title": "小熊优恩",
      "img": "https://p.ssl.qhimg.com/dmfd/224_314_75/d/dy_619ae44129a566ac4e4bc1e5004f8406.jpg.webp",
      "carousel": "4",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "高清",
      "license": "（闽）动审字[2015]第019号",
      "lang": "中文",
      "region": "大陆",
      "actor": "骆妍倩 / 陈旭昇 / 乐嘉晔 / 吕佩玉 / 刘以嘉 / 王愫酥",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "一心照顾调皮孩子的“新爸爸”-阿憨；专注工作、同时也爱着孩子的“新妈妈”-莉莉；还有他们聪明顽皮，状况不断的宝贝儿子-“优恩”——他们一起为我们带来了一个关于新生家庭的奇妙故事。 没有人教过阿憨怎么养大孩子从而笑料百出的优恩。寓教于乐，这是一部超级奶爸的成长史，也是一部欢乐育儿的教科书，给大家带来快乐的感受。",
      "video": "bear"
    },
    {
      "index": "3",
      "title": "功夫家族之笨笨鼠",
      "img": "https://p.ssl.qhimg.com/dmfd/224_314_75/d/dy_49ed71161206cfd4bd5b73bad0b1685b.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（闽）动审字[2013]第050号",
      "lang": "中文",
      "region": "大陆",
      "actor": "笨笨鼠 / 反斗熊 / 爱心兔 / 一米熊",
      "classify": "益智",
      "years": "2013",
      "director": "李竹兵",
      "intro": "功夫村里住着笨笨鼠、反斗熊、爱心兔、一米熊四个好朋友。笨笨鼠是个大智若愚的乐天派，不管世界怎样，即使把事情搞砸也能自得其乐。反斗熊是个有着大力气但头脑简单的家伙，笨笨鼠最“亲密”的朋友，只要有笨笨鼠的地方总会有他的身影，两人在一起总能闹出一些让人发笑的故事，当然最后常常是看似弱小的笨笨鼠获得胜利。爱心兔是个爱幻想爱撒娇喜欢一切粉红事物的小女生，也是笨笨鼠和反斗熊抢着帮助的对象。一米熊是只不够自信又渴望强大的小熊，思维简单但心地善良，但也常常好心办坏事。四个性格不同的朋友在一起看似打打闹闹，但其实谁也离不开谁，内心里都把彼此当做不可缺的朋友，为紧张和压力下的现代观众带来了一幕幕源于生活的欢乐故事",
      "video": "mouse"
    },
    {
      "index": "12",
      "title": "土楼探险之牛牛和妞妞",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/legend2.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2013]第017号",
      "lang": "中文",
      "region": "大陆",
      "actor": "付洁 /  马奇 /  张继伟 /  周正",
      "classify": "神话",
      "years": "2013",
      "director": "徐辉",
      "intro": "牛牛和妞妞与织女在鹊桥相会，淘气的妞妞失足落入人间。为了找回妹妹，牛牛在太白金星的指引下，来到永定的土楼中找到了妞妞，但牛牛发现妹妹失忆了，妹妹身上拥有守护神力祥云也不见了。邪恶的夜魔及其手下老鼠夺走了祥云。牛牛在土楼朋友们的帮助下，使妞妞恢复了记忆，并最终战胜夜魔。",
      "video": "house"
    },
    {
      "index": "1",
      "title": "熊猫博士",
      "img": "https://p.ssl.qhimg.com/d/dy_f4f98ebe5b74ae167a9a03bc16841484.jpg",
      "carousel": "5",
      "country": "中国",
      "type": "动画片",
      "setNum": "39",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "docotor"
    },
    // {
    //   "index": "2",
    //   "title": "熊猫博士和拖拖（二）",
    //   "img": "https://p0.ssl.qhimg.com/dmsmfl/120_80_/d/dy_efbd31e9b79be959eee345ee877f9d35.jpg.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video2"
    // },
    // {
    //   "index": "3",
    //   "title": "熊猫博士和拖拖（三）",
    //   "img": "https://p.ssl.qhimg.com/d/dy_9b8cafca1c4629bfd8e0dc7d96c3035c.jpg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video3"
    // },
    // {
    //   "index": "4",
    //   "title": "熊猫博士和拖拖第一季英文版",
    //   "img": "https://p.ssl.qhimg.com/d/dy_efbd31e9b79be959eee345ee877f9d35.jpg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "50",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video4"
    // },
    // {
    //   "index": "5",
    //   "title": "熊猫博士和拖拖第二季英文版",
    //   "img": "https://p.ssl.qhimg.com/d/dy_efbd31e9b79be959eee345ee877f9d35.jpg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video5"
    // },
    // {
    //   "index": "6",
    //   "title": "熊猫博士和拖拖第三季英文版",
    //   "img": "https://p.ssl.qhimg.com/d/dy_9b8cafca1c4629bfd8e0dc7d96c3035c.jpg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "40",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video6"
    // },
    // {
    //   "index": "7",
    //   "title": "熊猫博士看世界：安全消防课",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda6.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "3",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "科普",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video7"
    // },
    // {
    //   "index": "8",
    //   "title": "熊猫博士看世界：垃圾分类总动员",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda7.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "2",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "科普",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video8"
    // },
    // {
    //   "index": "9",
    //   "title": "熊猫博士看世界：汽车的小秘密",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda8.jpeg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "1",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "科普",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video9"
    // },
    // {
    //   "index": "10",
    //   "title": "熊猫博士看世界：新冠肺炎全科普",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda9.jpeg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "4",
    //   "duration": "",
    //   "totalDuration": "",
    //   "mediaType": "",
    //   "license": "",
    //   "lang": "",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "科普",
    //   "years": "2019",
    //   "director": "",
    //   "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
    //   "video": "video10"
    // }
    {
      "title": "摩比传说",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mobi-legend.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "32",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2013",
      "director": "",
      "intro": "《摩比传说》目前已在好未来全国各个分校推广，为孩子的课间生活增加了很多乐趣，而动画片中的人物也被广泛置入好未来的课件和文具中，生动可爱的卡通形象深受孩子的喜爱",
      "video": "legend"
    }
  ],
  original: [
    {
      "index": "1",
      "title": "轰轰龙之超级汽车救援队",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dragons.jpg.webp",
      "carousel": "1",
      "country": "中国",
      "type": "动画片",
      "setNum": "20",
      "duration": "3",
      "totalDuration": "60",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220504001",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "彭颉颉",
      "intro": "《轰轰龙之超级汽车救援队》是一档集合恐龙、汽车及救援知识的儿童益智动画片。孩子们将跟随快乐勇敢的轰轰龙、聪明的啾啾龙，博学多识的龟博士一起出动，通过极富想象力的超级汽车变身，在他们生活的小城里，圆满完成救援任务。感受爱与友谊，培养孩子的同情心和正义感。",
      "video": "car"
    },
    {
      "index": "2",
      "title": "小泼猴与哼哼猪",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/monkey.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "52",
      "duration": "3",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220504002",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "是一档关于亲子、友情、教育的原创少儿益智动画节目，面向3-12岁儿童。致力于将有价值的百科知识，以简单易懂的方式融入到生动精彩的故事中，有温度、开脑洞。孩子们将跟随小泼猴和哼哼猪一起，体验一次次奇妙的科学旅程。",
      "video": "pig"
    },
    {
      "index": "3",
      "title": "甜蜜日记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dairy.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "6",
      "totalDuration": "78",
      "mediaType": "高清",
      "license": "（鄂）动审字（2021）第003号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智、亲情、科普",
      "years": "未知",
      "director": "未知",
      "intro": "本片涵盖了关于I型糖尿病的各类知识和应对措施，讲述了在医生家人的细心帮助下，患病儿童乐乐积极面对、勇敢对抗疾病的生活日常，以及在控糖精灵糖小超的帮助下健康快乐成长的温暖故事，传达了科学治疗的理念和积极乐观的生活态度。",
      "video": "sweet"
    },
    {
      "index": "4",
      "title": "穿越云南三千年-云小志漫游记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/yunlan1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "10",
      "duration": "13",
      "totalDuration": "130",
      "mediaType": "高清",
      "license": "（云）动审字[2020]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "历史、益智",
      "years": "未知",
      "director": "未知",
      "intro": "讲述了一个酷爱历史的小男孩—云小志，偶遇传说中的上古神兽白泽。小志发现白泽对他佩戴的祖父留下的一块古玉很感兴趣，但并不知道这块古玉真正的作用。于是小志用这块古玉诱惑白泽，带他亲眼见证各种历史人物的事迹，解答各种奇怪的问题，在过程中探究古玉的秘密。",
      "video": "yunnan1"
    },
    {
      "index": "5",
      "title": "穿越云南三千年-云小志漫游记（第二季）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/yunlan1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "11",
      "duration": "13",
      "totalDuration": "143",
      "mediaType": "高清",
      "license": "（云）动审字[2022]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "历史、益智",
      "years": "未知",
      "director": "未知",
      "intro": "讲述了一个酷爱历史的小男孩—云小志，偶遇传说中的上古神兽白泽。小志发现白泽对他佩戴的祖父留下的一块古玉很感兴趣，但并不知道这块古玉真正的作用。于是小志用这块古玉诱惑白泽，带他亲眼见证各种历史人物的事迹，解答各种奇怪的问题，在过程中探究古玉的秘密。",
      "video": "yunnan2"
    },
    {
      "index": "7",
      "title": "翻开这一页第一季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "13",
      "totalDuration": "338",
      "mediaType": "高清",
      "license": "（湘）动审字[2014]第004号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "为向建国65周年献礼，国家新闻出版广电总局将于2014年国庆节推出《翻开这一页》、《戚继光》、《冯子材》三大主题“中国梦”电视动画项目，并要求全国各大卫视安排推荐播出。作为一项重大政治任务，动漫主力军的湖南与北京、上海分别接受其中一部电视动画片的生产。湖南广播电视台因强大的创新能力和平台影响力，获唯一近现代主题《翻开这一页》的立项制作，具体项目由金鹰卡通负责。",
      "video": "Onepage01"
    },
    {
      "index": "8",
      "title": "翻开这一页第二季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page2.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "12",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "（湘）动审字[2016]第008号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "为向建党95周年献礼，国家新闻出版广电总局将于2016年7月1日推出 “中国梦”电视动画系列片。《翻开这一页》第二季取材于小学语文、思品、历史等课本中的13个经典故事，用故事来塑造人物。将采用二维+三维的动画技术，生动的还原课本里的故事。从另一个视角为课本里的 “中国梦”做生动解读。",
      "video": "Onepage02"
    },
    {
      "index": "9",
      "title": "翻开这一页第三季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page3.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "10",
      "duration": "13",
      "totalDuration": "130",
      "mediaType": "高清",
      "license": "（湘）动审字[2017]第004号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《翻开这一页》第三季项目被国家新闻出版广电总局列为献礼十九大重点动画片项目，由湖南金鹰卡通承制，并将于2017年10月播出。《翻开这一页》第三季从课本中精心选取了五个具有代表性的人物，以“我的爸爸李大钊”、“一代传奇将领许世友”、“革命母亲江姐的红色遗书”、“孔繁森的高原赞歌”和“竺可桢解读大自然的语言”为核心故事",
      "video": "Onepage03"
    },
    {
      "index": "10",
      "title": "翻开这一页第四季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page4.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "10",
      "duration": "13",
      "totalDuration": "130",
      "mediaType": "高清",
      "license": "（湘）动审字[2021]第003号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《翻开这一页》第四季是金鹰卡通为献礼建党一百周年推出的重点动画项目。回首百年前，嘉兴南湖游船上的青年们，于黑夜点燃一盏明灯，在迷雾中照亮前进方向。回望过去，各行各业千千万万个奋斗者们，始终坚定理想信念，保持奋斗精神，将个人前途和国家命运炙热相融，才有今日之中国。",
      "video": "Onepage04"
    },
    // {
    //   "index": "11",
    //   "title": "乐乐虎大世界",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/happy.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "38",
    //   "duration": "13",
    //   "totalDuration": "494",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字[2018]第024号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智、亲子、轻松",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "让我们一起来重温童年、分享乐乐虎和点点虎一家的生活趣事吧！",
    //   "video": "tiger"
    // },
    // {
    //   "index": "12",
    //   "title": "快乐故事屋",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/story.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "52",
    //   "duration": "11",
    //   "totalDuration": "572",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字[2016]第031号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智、亲子、轻松",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "本片主要讲述了52个精美的童话故事。白鼠公主因贪玩而耽误了国事，但后来她知错就改；富有的大熊因为懒惰变得一无所有，贫穷的小老鼠却用勤劳的双手为自己挣得了一座大别墅……动画片围绕懂得尊重、乐于分享、消除胆怯、积极乐观、树立自信、学会交往、知情感恩、勤奋进取、克服缺点、激发爱心等十大主题，促进儿童心理健康和情商水平的发展，从而逐步形成独立、积极、稳定、健康的人格。",
    //   "video": "happy"
    // },
    // {
    //   "index": "13",
    //   "title": "萌果乐多多之水果勋章（一）",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/more.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "26",
    //   "duration": "8",
    //   "totalDuration": "208",
    //   "mediaType": "高清",
    //   "license": "（苏）动审字[2017]第007号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智、亲子、轻松",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "水果们快乐地生活在水果店中，每天都会迎来新的水果加入这个大家庭。此片通过剧情的巧妙引导，向少年儿童宣传食用水果的知识与益处，引导养成健康的饮食习惯",
    //   "video": "fruit"
    // },
    {
      "index": "16",
      "title": "丰丰农场之肥虫豆豆第一部",
      "img": "https://p.ssl.qhimg.com/dmfd/224_314_75/d/dy_57886377f503c7334ff70b484e4c0d28..webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13",
      "totalDuration": "169",
      "mediaType": "高清",
      "license": "（豫）动审字[2016]第004号",
      "lang": "中文",
      "region": "大陆",
      "actor": "豆豆,长鼻子,螳螂,圣甲爷爷",
      "classify": "科普",
      "years": "未知",
      "director": "未知",
      "intro": "以一条呆萌可爱的肥虫豆豆为主要角色，以丰丰农场中一片生机盎然的花园和生活在花盆公寓中的虫子世界为故事背景，讲述了住在农场花盆公寓中的虫虫们日常生活中发生的一个个或温馨、或浪漫、或有趣的故事。",
      "video": "farm01"
    },
    {
      "index": "17",
      "title": "丰丰农场之肥虫豆豆第二部",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bug1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13",
      "totalDuration": "169",
      "mediaType": "高清",
      "license": "（豫）动审字[2016]第005号",
      "lang": "中文",
      "region": "大陆",
      "actor": "豆豆,长鼻子,螳螂,圣甲爷爷",
      "classify": "科普",
      "years": "未知",
      "director": "未知",
      "intro": "以一条呆萌可爱的肥虫豆豆为主要角色，以丰丰农场中一片生机盎然的花园和生活在花盆公寓中的虫子世界为故事背景，讲述了住在农场花盆公寓中的虫虫们日常生活中发生的一个个或温馨、或浪漫、或有趣的故事。",
      "video": "farm02"
    },
    {
      "index": "21",
      "title": "吉木故事会",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mu.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "12",
      "totalDuration": "312",
      "mediaType": "高清",
      "license": "（闽）动审字[2011]第045号",
      "lang": "中文",
      "region": "大陆",
      "actor": "吉木,雷龙,雷虎,酷妹",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "秋末冬初，进入一年的农闲时节。雷龙雷虎又开始不安分，到处惹是生非，镇子被他们搞得鸡犬不宁，这样下去可不行。镇长和桑叔商量过后，做出了一个重要的决定——办一个豚鼠学堂。",
      "video": "wood"
    },
    {
      "index": "22",
      "title": "嗨，顾得白之快乐成长",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/grow.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "80",
      "duration": "3",
      "totalDuration": "240",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第051号",
      "lang": "中文",
      "region": "大陆",
      "actor": "顾得白",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "新学期，顾得白走进幼儿园，和同学们分享暑假趣事。聊天过程中，他了解到随便打断别人说话是不礼貌的行为。幼儿园的生活总会有小摩擦，顾得白和好朋友球球闹矛盾了，在妈妈的开导下，顾得白懂得了友谊可贵的道理。一次散步时，顾得白捡到了一只流浪狗，他给流浪狗取名叫果果。一人一狗的相处十分有趣，顾得白也因此学会了爱护小动物。新的学期，顾得白体会到了更多的爱。",
      "video": "growth"
    },
    {
      "index": "23",
      "title": "托雷的玩具城 第1部",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/toy.webp",
      "carousel": "3",
      "country": "中国",
      "type": "动画片",
      "setNum": "25",
      "duration": "10",
      "totalDuration": "250",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第027号",
      "lang": "中文",
      "region": "大陆",
      "actor": "柯奇",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "主角柯奇是一个真诚善良，但性格有些冲动的玩具机器人。在危急时刻，他遇到了另一群玩具——聪慧的黑包子、沉稳的刀剑客、热心的小骨头、勇敢的点点、机智的嗦发。在他们共同帮助下，柯奇很快融入了友爱的玩具之家。好景不长，玩具之家被老鼠皮条破坏，大家不知该何去何从。这时，黑包子告诉大家，玩具城城主托雷能为玩具们实现任何愿望。于是众人决定结伴前往托雷玩具城。新世界的大门在众人面前缓缓打开，等待他们的，是未知的际遇",
      "video": "toy1"
    },
    {
      "index": "24",
      "title": "托雷的玩具城 第2部",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/toy.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "25",
      "duration": "10",
      "totalDuration": "250",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第036号",
      "lang": "中文",
      "region": "大陆",
      "actor": "柯奇",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "主角柯奇和他的小伙伴们一行依然走在寻找托雷城主的路上。他们来到音符广场，差点沉迷其中，幸亏有点点的提示，他们才得以清醒。众人再次踏上旅途，而此时的托雷城主已经被可怕的皮鼠王所控制。危急关头，大家一路上帮助过的小镇居民及时赶到，齐心协力赶跑了皮鼠和老鼠军团。但黑包子却为了拯救大家而牺牲了自己。清醒过来的托雷城主用魔法恢复了黑包子的生命。大家的脸上重新扬起笑容，这一路同行让他们明白，最重要的就是大家能永远在一起。",
      "video": "toy2"
    },
    {
      "index": "25",
      "title": "嗨，顾得白之爱最珍贵",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/treasure.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "80",
      "duration": "3",
      "totalDuration": "240",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第051号",
      "lang": "",
      "region": "",
      "actor": "顾得白",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "新学期，顾得白走进幼儿园，和同学们分享暑假趣事。聊天过程中，他了解到随便打断别人说话是不礼貌的行为。幼儿园的生活总会有小摩擦，顾得白和好朋友球球闹矛盾了，在妈妈的开导下，顾得白懂得了友谊可贵的道理。一次散步时，顾得白捡到了一只流浪狗，他给流浪狗取名叫果果。一人一狗的相处十分有趣，顾得白也因此学会了爱护小动物。新的学期，顾得白体会到了更多的爱。",
      "video": "precious"
    },
    {
      "index": "26",
      "title": "老子道德三百问（第一季）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/laozi.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "50",
      "duration": "13",
      "totalDuration": "650",
      "mediaType": "高清",
      "license": "（冀）动审字[2014]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "该片讲述了李耳(后人尊称其为老子)从幼年时期开始，天资颖慧，在李母与开蒙老师商容的谆谆善诱下，与小智、小石、小月等三个小伙伴相濡以沫，一同求知问学的故事。",
      "video": "moral01"
    },
    {
      "index": "27",
      "title": "老子道德三百问（第二季）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/laozi.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "50",
      "duration": "13",
      "totalDuration": "650",
      "mediaType": "高清",
      "license": "（冀）动审字[2014]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "该片讲述了李耳(后人尊称其为老子)从幼年时期开始，天资颖慧，在李母与开蒙老师商容的谆谆善诱下，与小智、小石、小月等三个小伙伴相濡以沫，一同求知问学的故事。",
      "video": "moral02"
    },
    // {
    //   "index": "28",
    //   "title": "精灵爱牙讲堂之口腔健康知识",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/teeth.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "20",
    //   "duration": "4",
    //   "totalDuration": "80",
    //   "mediaType": "高清",
    //   "license": "（鄂）动审字[2015]第003号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "牙牙精灵",
    //   "classify": "科普",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "影片以人的牙齿为原型，设计主角牙牙精灵。通过讲述牙牙精灵跟随武大口腔医院牙博士接诊患者、参加口腔知识社区等故事，向广大观众宣传专业的口腔健康知识，以此提醒广大消费者增强口腔健康保护意识。",
    //   "video": "Health"
    // },
    {
      "index": "29",
      "title": "牙牙精灵战队",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/teeth2.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "20",
      "duration": "7",
      "totalDuration": "140",
      "mediaType": "高清",
      "license": "（鄂）动审字[2019]第003号",
      "lang": "中文",
      "region": "大陆",
      "actor": "牙牙队长  美牙牙  壮牙牙等",
      "classify": "科普",
      "years": "未知",
      "director": "未知",
      "intro": "本动画以牙牙精灵队长为主角，其成立的牙牙精灵战队中4个功能及性格各异的队员让剧情更加饱满。摒弃传统的科普演绎形式，把所有牙病拟人卡通化，变成一个个有性格有破坏技能的病菌怪，通过病菌们搞破坏的演绎，阐释清楚各类口腔疾病的根源。其幽默风趣的表演，将变繁冗为简单,打破口腔病理上的理解障碍，革新晦涩文字带来的沉闷。",
      "video": "teeth",
    },
    {
      "index": "30",
      "title": "玩个玩具之芭比的大房子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.47",
      "totalDuration": "5.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "house2"
    },
    {
      "index": "31",
      "title": "玩个玩具之一只神奇的兔子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.17",
      "totalDuration": "5.17",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "rabbit"
    },
    {
      "index": "32",
      "title": "玩个玩具之拯救企鹅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.47",
      "totalDuration": "6.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "penguin"
    },
    {
      "index": "33",
      "title": "玩个玩具之抓住那个捣蛋鬼",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.19",
      "totalDuration": "5.19",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "youngduck"
    },
    {
      "index": "34",
      "title": "玩个玩具之翻斗猴子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.23",
      "totalDuration": "6.23",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "mokey"
    },
    {
      "index": "35",
      "title": "玩个玩具之佩奇的生日礼物奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.39",
      "totalDuration": "6.39",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "strangeegg"
    },
    {
      "index": "36",
      "title": "玩个玩具之欢迎来到兔叽咖啡厅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.04",
      "totalDuration": "5.04",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "coffee"
    },
    {
      "index": "37",
      "title": "玩个玩具之疯狂动物城奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.5",
      "totalDuration": "6.5",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "eggs"
    },
    {
      "index": "38",
      "title": "玩个玩具之欢乐水族箱",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.08",
      "totalDuration": "6.08",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "vide": "waterbox"
    },
    {
      "index": "39",
      "title": "玩个玩具之迪士尼陶艺机",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "7.14",
      "totalDuration": "7.14",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "machine"
    },
    {
      "index": "40",
      "title": "玩个玩具之彩泥霓虹工坊",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.49",
      "totalDuration": "6.49",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "workshop"
    },
    {
      "index": "41",
      "title": "玩个玩具之星海湾游乐场游记",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.57",
      "totalDuration": "5.57",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "vide": "playground"
    },
    {
      "index": "42",
      "title": "探索地球村",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/earth.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "",
      "duration": "",
      "totalDuration": "299",
      "mediaType": "高清",
      "license": "（黑）动审字【2007】第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "探索地球村用生动的画面和幽默有趣的故事帮助孩子们认识这个神奇而美丽的世界，让他们了解各种千奇百怪的自然现象是如何产生的，让孩子们从小树立热爱科学、关心自然的观念，培养他们善于观察、勇于探素的良好习惯。讲述了聪明美丽的人鱼小齐、尤尤，小海龟阿乖，小海豹达达，小沙鱼大阔，螃蟹老师、鱼博士的故事",
      "video": "earthCountry"
    },
    {
      "index": "1",
      "title": "小熊优恩",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bear.jpg.webp",
      "carousel": "4",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "高清",
      "license": "（闽）动审字[2015]第019号",
      "lang": "中文",
      "region": "大陆",
      "actor": "骆妍倩 / 陈旭昇 / 乐嘉晔 / 吕佩玉 / 刘以嘉 / 王愫酥",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "一心照顾调皮孩子的“新爸爸”-阿憨；专注工作、同时也爱着孩子的“新妈妈”-莉莉；还有他们聪明顽皮，状况不断的宝贝儿子-“优恩”——他们一起为我们带来了一个关于新生家庭的奇妙故事。 没有人教过阿憨怎么养大孩子从而笑料百出的优恩。寓教于乐，这是一部超级奶爸的成长史，也是一部欢乐育儿的教科书，给大家带来快乐的感受。",
      "video": "bear"
    },
    {
      "index": "2",
      "title": "卫浴也疯狂",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bath.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（苏）动审字[2015]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": " 洗脸台 /  水龙头 /  抽水马桶 /  花洒",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "平淡无趣的卫生间里迎来了一群疯狂可爱的新伙伴，他们是洗脸台、水龙头、抽水马桶、花洒以及淋浴房。在这个看似普通的卫浴间里，每当主人不在或是夜幕降临的时候，这里就会呈现出另一番景象。 生活在这里的卫浴们被赋予了生命，面对麻烦制造者 “病菌拉吉”和沙皮狗“乌眼青”的破坏行动，卫浴们与捣蛋分子斗智斗勇，在嬉笑怒骂中打赢了一次又一次的家园保卫战",
      "video": "bath"
    },
    {
      "index": "3",
      "title": "功夫家族之笨笨鼠",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mouse.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（闽）动审字[2013]第050号",
      "lang": "中文",
      "region": "大陆",
      "actor": "笨笨鼠 / 反斗熊 / 爱心兔 / 一米熊",
      "classify": "益智",
      "years": "2013",
      "director": "李竹兵",
      "intro": "功夫村里住着笨笨鼠、反斗熊、爱心兔、一米熊四个好朋友。笨笨鼠是个大智若愚的乐天派，不管世界怎样，即使把事情搞砸也能自得其乐。反斗熊是个有着大力气但头脑简单的家伙，笨笨鼠最“亲密”的朋友，只要有笨笨鼠的地方总会有他的身影，两人在一起总能闹出一些让人发笑的故事，当然最后常常是看似弱小的笨笨鼠获得胜利。爱心兔是个爱幻想爱撒娇喜欢一切粉红事物的小女生，也是笨笨鼠和反斗熊抢着帮助的对象。一米熊是只不够自信又渴望强大的小熊，思维简单但心地善良，但也常常好心办坏事。四个性格不同的朋友在一起看似打打闹闹，但其实谁也离不开谁，内心里都把彼此当做不可缺的朋友，为紧张和压力下的现代观众带来了一幕幕源于生活的欢乐故事",
      "video": "mouse"
    },
    {
      "index": "4",
      "title": "卡西龙之寻龙记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dragons.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2012]第018号",
      "lang": "中文",
      "region": "大陆",
      "actor": "阿尔 / 小玮 / 琳达 / 金金 / 威威 / 西西",
      "classify": "科幻",
      "years": "2012",
      "director": "李竹兵",
      "intro": "太阳系中有一个神秘的龙族，是维护宇宙正义的战族，他们在最危急的时刻会出现在需要的星系，而战龙的养成绝非偶然，必须组成团队家族，而按各属性安排在不同的行星诞生成长感受正义与力量",
      "video": "dragon"
    },
    {
      "index": "5",
      "title": "蔡六",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/six.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "24",
      "duration": "5",
      "totalDuration": "120",
      "mediaType": "标清",
      "license": "（闽）动审字[2011]第021号",
      "lang": "中文",
      "region": "大陆",
      "actor": "蔡六",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "有个人叫蔡六，他非常喜欢恶作剧、捉弄人，但他恶作剧对象主要为吝啬地主、不法商人、贪官污吏等。如蔡六看到老百姓买水缸被欺负，用计让商贩尝尽苦头，替老百姓出了口恶气",
      "video": "six"
    },
    {
      "index": "6",
      "title": "石头娃",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/stone.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "13",
      "totalDuration": "338",
      "mediaType": "高清",
      "license": "（苏）动审字[2018]第009号",
      "lang": "中文",
      "region": "大陆",
      "actor": "地客 /  憨憨 /  雨雨 /  花花",
      "classify": "冒险",
      "years": "2019",
      "director": "张瑶",
      "intro": "以南京雨花石为动漫造型，讲述了神奇的雨花石精灵带着一个机智可爱的小学生雨雨穿越时光旅行，展现一个神奇的科幻世界：史前动植物的消失，能源的危机， 海啸、 火山的形成，大裂谷的跋涉和冰川的消融等等，雨雨最终破译“智慧之门”的密码",
      "video": "stone"
    },
    {
      "index": "7",
      "title": "少年张謇",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/youth.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "12",
      "totalDuration": "312",
      "mediaType": "高清",
      "license": "（苏）动审字[2017]第017号",
      "lang": "中文",
      "region": "大陆",
      "actor": "罗玉婷 / 蒋可 / 王燕华 / 胡谦 / 李晔",
      "classify": "",
      "years": "",
      "director": "娄朋庆",
      "intro": "张謇是聪明机智、敢于创新、忧国忧民的孩子，这些品质促使后来的张謇做出创办学校、兴修公共设施等伟大的事情，成为影响中国近代历史的重要角色。这是一部以清末状元张謇的少儿时期生活为主要内容的历史题材动画片。通过动画这种幽默、夸张的艺术形式，表现少儿时期的张謇身上所具备的独特性格品质。",
      "video": "youth"
    },
    // {
    //   "index": "8",
    //   "title": "嘟嘟镇",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/city.jpeg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "益智",
    //   "setNum": "52",
    //   "duration": "13",
    //   "totalDuration": "676",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字【2016】035号",
    //   "lang": "",
    //   "region": "",
    //   "actor": "顾烨",
    //   "classify": "亲子、教育",
    //   "years": "2016",
    //   "director": "应勋",
    //   "intro": "故事讲述了刚到嘟嘟镇工作的快递员阿卡，突然被卷入一场盗窃案中，被误会成小偷，上演了一场闹剧。后来误会化解，阿卡也在这场事件中渐渐熟悉了小镇上每位成员，他也靠着勤奋、热心与诚实获得了大家的认可。之后，整个小镇围绕着阿卡上演起一幕幕或幽默、或紧张、或温情的小故事，通过剧情传达爱与关怀的人文精神，教育小朋友友爱互助，关心社会与环境，拥抱梦想并热爱生活",
    //   "video": "cities"
    // },
    {
      "index": "9",
      "title": "百越历险记之壮锦密码",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/heros.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "12",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "（桂）动审字[2017]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "刘三姐 / 小昭 / 猴小白 / 卡索 / 呱呱国师",
      "classify": "其他",
      "years": "2017",
      "director": "卢军",
      "intro": "万年前，祖洛神和天仙灵珊与魔王决战于米洛仙山岜赤山顶，最终大败魔王并用12圣器将魔界与人间的通道封印，天仙灵珊舍身取义壮烈牺牲。为防万年后“七星连珠”之际魔界再次为祸人间，祖洛神留下12圣器分藏于百越大地，并派米洛王族世代镇守岜赤山。天仙灵珊在封印魔界时功力耗尽，万年之后转世人间，只有她才能运用十二圣器，用她的歌声把铜鼓等12圣器组合成天音法阵，才能彻底封印魔王，而这个人就是米洛王的三公主婉馨，她在壮王的指引下，解开了壮锦的秘密，按照壮锦地图的指引完成任务。",
      "video": "code"
    },
    {
      "index": "10",
      "title": "铜鼓奇缘",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/drum.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "14",
      "duration": "11",
      "totalDuration": "154",
      "mediaType": "高清",
      "license": "（桂）动审字[2019]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "刘婉馨 / 唐筱米 / 猴小白 / 武石甲 / 穆莱尔 / 高拉·索朗弓",
      "classify": "神话",
      "years": "2019",
      "director": "李尚玻",
      "intro": "塞壬来源自古老的希腊神话传说，在神话中的她被塑造成一名人面鸟身的海妖，飞翔在大海上，拥有天籁般的歌喉，常用歌声诱惑过路的航海者而使航船触礁沉没，船员则成为塞壬的腹中餐。别有用心的塞壬高科技公司，受传说的海上女妖故事启发，开展魔音计划，在东南亚的无人岛上建设了TEM高频声波传输发射塔，从世界各地选出歌声与魔音高度匹配的歌手，用高科技系统把歌手魔化，再利用发射塔把魔音声波发射到海上丝绸之路航线上，欲以此手段控制船员实现海盗计划。 ",
      "video": "drum"
    },
    {
      "index": "11",
      "title": "瓷都传奇之牛牛和妞妞",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/legend.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "12",
      "totalDuration": "312",
      "mediaType": "高清",
      "license": "（闽）动审字[2016]第008号",
      "lang": "中文",
      "region": "大陆",
      "actor": "王亚琳 / 叶方 / 王辛 / 唐泽宗 / 王雪沁 / 丁妍",
      "classify": "神话",
      "years": "2017",
      "director": "徐辉",
      "intro": "牛牛和妞妞来到瓷都德化，遇到正苦恼于改进瓷窑的窑神林炳。受牛牛和妞妞的启发，林炳成功建成龙窑，提高了瓷器的产量。大盗烮震在远洋大船海南一号建成之际，偷走了龙窑里的凌火瓷珠，瓷器的生产受阻。经过努力，赶走了大盗，还帮助改进制瓷工艺。",
      "video": "legend1"
    },
    {
      "index": "12",
      "title": "土楼探险之牛牛和妞妞",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/legend2.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2013]第017号",
      "lang": "中文",
      "region": "大陆",
      "actor": "付洁 /  马奇 /  张继伟 /  周正",
      "classify": "神话",
      "years": "2013",
      "director": "徐辉",
      "intro": "牛牛和妞妞与织女在鹊桥相会，淘气的妞妞失足落入人间。为了找回妹妹，牛牛在太白金星的指引下，来到永定的土楼中找到了妞妞，但牛牛发现妹妹失忆了，妹妹身上拥有守护神力祥云也不见了。邪恶的夜魔及其手下老鼠夺走了祥云。牛牛在土楼朋友们的帮助下，使妞妞恢复了记忆，并最终战胜夜魔。",
      "video": "house"
    },
    {
      "index": "13",
      "title": "哈喽！葡星人",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/star1.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "15",
      "totalDuration": "390",
      "mediaType": "高清",
      "license": "（沪）动审字[2016]第013号",
      "lang": "中文",
      "region": "大陆",
      "actor": "塔塔 /  侯烨 /  裘莎莎 /  朱志摩",
      "classify": "益智",
      "years": "2016",
      "director": "刘思蜀",
      "intro": "外星人塔塔携宠物小Q与超越人类科技千年的高科技来到了地球。本以为能无往不利，结果一场意外，飞船报废，只好赖在地球男孩侯烨。侯烨平凡无奇的暑假彻底被颠覆，这个意外闯入的外星室友一边给他带来种种意想不到的麻烦，一边让侯烨见识到自己从未想象过的神奇科技：来自遥远光年外的葡星文明，千变万化的神秘探索器，眼前这个充满秘密的外星朋友。",
      "video": "star"
    },
    {
      "index": "14",
      "title": "哈喽！葡星人之极训特工",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/star2.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "15",
      "totalDuration": "390",
      "mediaType": "高清",
      "license": "（沪）动审字[2018]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "塔塔 /  侯烨 /  朱志摩 /  裘莎莎",
      "classify": "益智",
      "years": "2018",
      "director": "未知",
      "intro": "关于外星学霸塔塔来地球完成毕业报告时，因飞船意外报废，结识了地球少年侯烨。从此侯烨平凡无奇的暑假彻底被颠覆，在经历了一连串鸡飞狗跳的事件后，几个孩子从相互敌对，到成为朋友；从自我中心，到学会分享；从叛逆敷衍，到承担责任",
      "video": "star2"
    },
    {
      "index": "15",
      "title": "阿古顿巴",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/history.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "10",
      "totalDuration": "260",
      "mediaType": "高清",
      "license": "（藏）动审字【2017】第 01 号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2020",
      "director": "未知",
      "intro": "在雪域高原的山南地区有一个平凡的小村子，村里人世世代代、按部就班地过着平凡的日子，地主收租，农户种田，牧民放牧，卖杂货的走街串巷，村口还有一个小茶馆。突然有一天，不知从哪里来了一个四处流浪的人——阿古顿巴，打破了村民们平静的生活，故事就从这里开始了",
      "video": "bus1"
    },
    {
      "index": "16",
      "title": "阿古顿巴  第二季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/history2.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "10",
      "totalDuration": "260",
      "mediaType": "高清",
      "license": "（藏）动审字【2018】第 1 号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2020",
      "director": "未知",
      "intro": "在雪域高原的山南地区有一个平凡的小村子，村里人世世代代、按部就班地过着平凡的日子，地主收租，农户种田，牧民放牧，卖杂货的走街串巷，村口还有一个小茶馆。突然有一天，不知从哪里来了一个四处流浪的人——阿古顿巴，打破了村民们平静的生活，故事就从这里开始了。",
      "video": "bus2"
    },
    {
      "index": "17",
      "title": "魔能圣甲：守护者",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/protected.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "8",
      "totalDuration": "208",
      "mediaType": "1920*1080",
      "license": "（粤）动审字【2019】第014号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "科幻",
      "years": "未知",
      "director": "未知",
      "intro": "由于地球资源枯竭,人类面临着严重的死亡威胁,地球即将走向灭亡。科学家推出“立方计划(HEXA)”,旨在于太空中寻找一个人类宜居星球",
      "video": "protected"
    },
    {
      "index": "18",
      "title": "么么侠 第一季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/hero.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13.5",
      "totalDuration": "175.5",
      "mediaType": "1920*1080",
      "license": "（苏）动审字【2022】第005号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "科幻",
      "years": "2020",
      "director": "未知",
      "intro": "在深邃的宇宙中，有一颗美丽的绿色星球——雷普星，在雷普星上，植被遍地，生态和谐，人们安居乐业。雷普星外，有一颗小卫星么么星，雷普星的守护者初代么么侠就住在这里，远远的守望着雷普星和上面的人们。 几百年前，来自宇宙深处的破坏者——混沌王发现了雷普星，他打算把雷普星变成生命灭绝，岩浆横流的死星。为了保护雷普星，初代么么侠和污污大王展开了一场殊死决战。",
      "video": "hero"
    },
    {
      "index": "1",
      "title": "熊猫博士",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda1.jpeg",
      "carousel": "5",
      "country": "中国",
      "type": "动画片",
      "setNum": "39",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "docotor"
    },
    {
      "index": "2",
      "title": "熊猫博士和拖拖（二）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda2.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video2"
    },
    {
      "index": "3",
      "title": "熊猫博士和拖拖（三）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda3.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video3"
    },
    {
      "index": "4",
      "title": "熊猫博士和拖拖第一季英文版",
      "img": "https://p.ssl.qhimg.com/d/dy_efbd31e9b79be959eee345ee877f9d35.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "50",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video4"
    },
    {
      "index": "5",
      "title": "熊猫博士和拖拖第二季英文版",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda4.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video5"
    },
    {
      "index": "6",
      "title": "熊猫博士和拖拖第三季英文版",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda5.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video6"
    },
    {
      "index": "7",
      "title": "熊猫博士看世界：安全消防课",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda6.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "3",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video7"
    },
    {
      "index": "8",
      "title": "熊猫博士看世界：垃圾分类总动员",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda7.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "2",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video8"
    },
    {
      "index": "9",
      "title": "熊猫博士看世界：汽车的小秘密",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda8.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video9"
    },
    {
      "index": "10",
      "title": "熊猫博士看世界：新冠肺炎全科普",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda9.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "4",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "video": "video10"
    },
    {
      "title": "摩比传说",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mobi-legend.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "32",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2013",
      "director": "",
      "intro": "《摩比传说》目前已在好未来全国各个分校推广，为孩子的课间生活增加了很多乐趣，而动画片中的人物也被广泛置入好未来的课件和文具中，生动可爱的卡通形象深受孩子的喜爱",
      "video": "legend"
    }
  ],
  addData: [
    {
      "index": "1",
      "title": "轰轰龙之超级汽车救援队",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dragons.jpg.webp",
      "carousel": "1",
      "country": "中国",
      "type": "动画片",
      "setNum": "20",
      "duration": "3",
      "totalDuration": "60",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220504001",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "彭颉颉",
      "intro": "《轰轰龙之超级汽车救援队》是一档集合恐龙、汽车及救援知识的儿童益智动画片。孩子们将跟随快乐勇敢的轰轰龙、聪明的啾啾龙，博学多识的龟博士一起出动，通过极富想象力的超级汽车变身，在他们生活的小城里，圆满完成救援任务。感受爱与友谊，培养孩子的同情心和正义感。",
      "latest": "",
      "ranking": "",
      "hot": "是",
      "original": "是",
      "video": "car"
    },
    {
      "index": "2",
      "title": "小泼猴与哼哼猪",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/monkey.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "52",
      "duration": "3",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220504002",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "是一档关于亲子、友情、教育的原创少儿益智动画节目，面向3-12岁儿童。致力于将有价值的百科知识，以简单易懂的方式融入到生动精彩的故事中，有温度、开脑洞。孩子们将跟随小泼猴和哼哼猪一起，体验一次次奇妙的科学旅程。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "pig"
    },
    {
      "index": "3",
      "title": "甜蜜日记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dairy.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "6",
      "totalDuration": "78",
      "mediaType": "高清",
      "license": "（鄂）动审字（2021）第003号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智、亲情、科普",
      "years": "未知",
      "director": "未知",
      "intro": "本片涵盖了关于I型糖尿病的各类知识和应对措施，讲述了在医生家人的细心帮助下，患病儿童乐乐积极面对、勇敢对抗疾病的生活日常，以及在控糖精灵糖小超的帮助下健康快乐成长的温暖故事，传达了科学治疗的理念和积极乐观的生活态度。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "sweet"
    },
    {
      "index": "4",
      "title": "穿越云南三千年-云小志漫游记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/yunlan1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "10",
      "duration": "13",
      "totalDuration": "130",
      "mediaType": "高清",
      "license": "（云）动审字[2020]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "历史、益智",
      "years": "未知",
      "director": "未知",
      "intro": "讲述了一个酷爱历史的小男孩—云小志，偶遇传说中的上古神兽白泽。小志发现白泽对他佩戴的祖父留下的一块古玉很感兴趣，但并不知道这块古玉真正的作用。于是小志用这块古玉诱惑白泽，带他亲眼见证各种历史人物的事迹，解答各种奇怪的问题，在过程中探究古玉的秘密。",
      "latest": "",
      "ranking": "",
      "hot": "是",
      "original": "是",
      "video": "yunnan1"
    },
    {
      "index": "5",
      "title": "穿越云南三千年-云小志漫游记（第二季）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/yunlan1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "11",
      "duration": "13",
      "totalDuration": "143",
      "mediaType": "高清",
      "license": "（云）动审字[2022]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "历史、益智",
      "years": "未知",
      "director": "未知",
      "intro": "讲述了一个酷爱历史的小男孩—云小志，偶遇传说中的上古神兽白泽。小志发现白泽对他佩戴的祖父留下的一块古玉很感兴趣，但并不知道这块古玉真正的作用。于是小志用这块古玉诱惑白泽，带他亲眼见证各种历史人物的事迹，解答各种奇怪的问题，在过程中探究古玉的秘密。",
      "latest": "",
      "ranking": "",
      "hot": "是",
      "original": "是",
      "video": "yunnan2"
    },
    {
      "index": "7",
      "title": "翻开这一页第一季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "13",
      "totalDuration": "338",
      "mediaType": "高清",
      "license": "（湘）动审字[2014]第004号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "为向建国65周年献礼，国家新闻出版广电总局将于2014年国庆节推出《翻开这一页》、《戚继光》、《冯子材》三大主题“中国梦”电视动画项目，并要求全国各大卫视安排推荐播出。作为一项重大政治任务，动漫主力军的湖南与北京、上海分别接受其中一部电视动画片的生产。湖南广播电视台因强大的创新能力和平台影响力，获唯一近现代主题《翻开这一页》的立项制作，具体项目由金鹰卡通负责。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "Onepage01"
    },
    {
      "index": "8",
      "title": "翻开这一页第二季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page2.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "12",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "（湘）动审字[2016]第008号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "为向建党95周年献礼，国家新闻出版广电总局将于2016年7月1日推出 “中国梦”电视动画系列片。《翻开这一页》第二季取材于小学语文、思品、历史等课本中的13个经典故事，用故事来塑造人物。将采用二维+三维的动画技术，生动的还原课本里的故事。从另一个视角为课本里的 “中国梦”做生动解读。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "Onepage02"
    },
    {
      "index": "9",
      "title": "翻开这一页第三季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page3.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "10",
      "duration": "13",
      "totalDuration": "130",
      "mediaType": "高清",
      "license": "（湘）动审字[2017]第004号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《翻开这一页》第三季项目被国家新闻出版广电总局列为献礼十九大重点动画片项目，由湖南金鹰卡通承制，并将于2017年10月播出。《翻开这一页》第三季从课本中精心选取了五个具有代表性的人物，以“我的爸爸李大钊”、“一代传奇将领许世友”、“革命母亲江姐的红色遗书”、“孔繁森的高原赞歌”和“竺可桢解读大自然的语言”为核心故事",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "Onepage03"
    },
    {
      "index": "10",
      "title": "翻开这一页第四季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/page4.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "10",
      "duration": "13",
      "totalDuration": "130",
      "mediaType": "高清",
      "license": "（湘）动审字[2021]第003号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《翻开这一页》第四季是金鹰卡通为献礼建党一百周年推出的重点动画项目。回首百年前，嘉兴南湖游船上的青年们，于黑夜点燃一盏明灯，在迷雾中照亮前进方向。回望过去，各行各业千千万万个奋斗者们，始终坚定理想信念，保持奋斗精神，将个人前途和国家命运炙热相融，才有今日之中国。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "Onepage04"
    },
    // {
    //   "index": "11",
    //   "title": "乐乐虎大世界",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/happy.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "38",
    //   "duration": "13",
    //   "totalDuration": "494",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字[2018]第024号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智、亲子、轻松",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "让我们一起来重温童年、分享乐乐虎和点点虎一家的生活趣事吧！",
    //   "latest": "",
    //   "ranking": "",
    //   "hot": "",
    //   "original": "是",
    //   "video": "tiger"
    // },
    // {
    //   "index": "12",
    //   "title": "快乐故事屋",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/story.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "52",
    //   "duration": "11",
    //   "totalDuration": "572",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字[2016]第031号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智、亲子、轻松",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "本片主要讲述了52个精美的童话故事。白鼠公主因贪玩而耽误了国事，但后来她知错就改；富有的大熊因为懒惰变得一无所有，贫穷的小老鼠却用勤劳的双手为自己挣得了一座大别墅……动画片围绕懂得尊重、乐于分享、消除胆怯、积极乐观、树立自信、学会交往、知情感恩、勤奋进取、克服缺点、激发爱心等十大主题，促进儿童心理健康和情商水平的发展，从而逐步形成独立、积极、稳定、健康的人格。",
    //   "latest": "",
    //   "ranking": "",
    //   "hot": "",
    //   "original": "是",
    //   "video": "happy"
    // },
    // {
    //   "index": "13",
    //   "title": "萌果乐多多之水果勋章（一）",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/more.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "26",
    //   "duration": "8",
    //   "totalDuration": "208",
    //   "mediaType": "高清",
    //   "license": "（苏）动审字[2017]第007号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "未知",
    //   "classify": "益智、亲子、轻松",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "水果们快乐地生活在水果店中，每天都会迎来新的水果加入这个大家庭。此片通过剧情的巧妙引导，向少年儿童宣传食用水果的知识与益处，引导养成健康的饮食习惯",
    //   "latest": "",
    //   "ranking": "",
    //   "hot": "",
    //   "original": "是",
    //   "video": "fruit"
    // },
    {
      "index": "16",
      "title": "丰丰农场之肥虫豆豆第一部",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bug1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13",
      "totalDuration": "169",
      "mediaType": "高清",
      "license": "（豫）动审字[2016]第004号",
      "lang": "中文",
      "region": "大陆",
      "actor": "豆豆,长鼻子,螳螂,圣甲爷爷",
      "classify": "科普",
      "years": "未知",
      "director": "未知",
      "intro": "以一条呆萌可爱的肥虫豆豆为主要角色，以丰丰农场中一片生机盎然的花园和生活在花盆公寓中的虫子世界为故事背景，讲述了住在农场花盆公寓中的虫虫们日常生活中发生的一个个或温馨、或浪漫、或有趣的故事。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "farm01"
    },
    {
      "index": "17",
      "title": "丰丰农场之肥虫豆豆第二部",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bug1.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13",
      "totalDuration": "169",
      "mediaType": "高清",
      "license": "（豫）动审字[2016]第005号",
      "lang": "中文",
      "region": "大陆",
      "actor": "豆豆,长鼻子,螳螂,圣甲爷爷",
      "classify": "科普",
      "years": "未知",
      "director": "未知",
      "intro": "以一条呆萌可爱的肥虫豆豆为主要角色，以丰丰农场中一片生机盎然的花园和生活在花盆公寓中的虫子世界为故事背景，讲述了住在农场花盆公寓中的虫虫们日常生活中发生的一个个或温馨、或浪漫、或有趣的故事。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "farm02"
    },
    {
      "index": "21",
      "title": "吉木故事会",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mu.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "12",
      "totalDuration": "312",
      "mediaType": "高清",
      "license": "（闽）动审字[2011]第045号",
      "lang": "中文",
      "region": "大陆",
      "actor": "吉木,雷龙,雷虎,酷妹",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "秋末冬初，进入一年的农闲时节。雷龙雷虎又开始不安分，到处惹是生非，镇子被他们搞得鸡犬不宁，这样下去可不行。镇长和桑叔商量过后，做出了一个重要的决定——办一个豚鼠学堂。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "wood"
    },
    {
      "index": "22",
      "title": "嗨，顾得白之快乐成长",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/grow.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "80",
      "duration": "3",
      "totalDuration": "240",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第051号",
      "lang": "中文",
      "region": "大陆",
      "actor": "顾得白",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "新学期，顾得白走进幼儿园，和同学们分享暑假趣事。聊天过程中，他了解到随便打断别人说话是不礼貌的行为。幼儿园的生活总会有小摩擦，顾得白和好朋友球球闹矛盾了，在妈妈的开导下，顾得白懂得了友谊可贵的道理。一次散步时，顾得白捡到了一只流浪狗，他给流浪狗取名叫果果。一人一狗的相处十分有趣，顾得白也因此学会了爱护小动物。新的学期，顾得白体会到了更多的爱。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "growth"
    },
    {
      "index": "23",
      "title": "托雷的玩具城 第1部",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/toy.webp",
      "carousel": "3",
      "country": "中国",
      "type": "动画片",
      "setNum": "25",
      "duration": "10",
      "totalDuration": "250",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第027号",
      "lang": "中文",
      "region": "大陆",
      "actor": "柯奇",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "主角柯奇是一个真诚善良，但性格有些冲动的玩具机器人。在危急时刻，他遇到了另一群玩具——聪慧的黑包子、沉稳的刀剑客、热心的小骨头、勇敢的点点、机智的嗦发。在他们共同帮助下，柯奇很快融入了友爱的玩具之家。好景不长，玩具之家被老鼠皮条破坏，大家不知该何去何从。这时，黑包子告诉大家，玩具城城主托雷能为玩具们实现任何愿望。于是众人决定结伴前往托雷玩具城。新世界的大门在众人面前缓缓打开，等待他们的，是未知的际遇",
      "video": "toy1"
    },
    {
      "index": "24",
      "title": "托雷的玩具城 第2部",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/toy.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "25",
      "duration": "10",
      "totalDuration": "250",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第036号",
      "lang": "中文",
      "region": "大陆",
      "actor": "柯奇",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "主角柯奇和他的小伙伴们一行依然走在寻找托雷城主的路上。他们来到音符广场，差点沉迷其中，幸亏有点点的提示，他们才得以清醒。众人再次踏上旅途，而此时的托雷城主已经被可怕的皮鼠王所控制。危急关头，大家一路上帮助过的小镇居民及时赶到，齐心协力赶跑了皮鼠和老鼠军团。但黑包子却为了拯救大家而牺牲了自己。清醒过来的托雷城主用魔法恢复了黑包子的生命。大家的脸上重新扬起笑容，这一路同行让他们明白，最重要的就是大家能永远在一起。",
      "video": "toy2"
    },
    {
      "index": "25",
      "title": "嗨，顾得白之爱最珍贵",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/treasure.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "80",
      "duration": "3",
      "totalDuration": "240",
      "mediaType": "高清",
      "license": "（浙）动审字[2019]第051号",
      "lang": "",
      "region": "",
      "actor": "顾得白",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "新学期，顾得白走进幼儿园，和同学们分享暑假趣事。聊天过程中，他了解到随便打断别人说话是不礼貌的行为。幼儿园的生活总会有小摩擦，顾得白和好朋友球球闹矛盾了，在妈妈的开导下，顾得白懂得了友谊可贵的道理。一次散步时，顾得白捡到了一只流浪狗，他给流浪狗取名叫果果。一人一狗的相处十分有趣，顾得白也因此学会了爱护小动物。新的学期，顾得白体会到了更多的爱。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "precious"
    },
    {
      "index": "26",
      "title": "老子道德三百问（第一季）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/laozi.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "50",
      "duration": "13",
      "totalDuration": "650",
      "mediaType": "高清",
      "license": "（冀）动审字[2014]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "该片讲述了李耳(后人尊称其为老子)从幼年时期开始，天资颖慧，在李母与开蒙老师商容的谆谆善诱下，与小智、小石、小月等三个小伙伴相濡以沫，一同求知问学的故事。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "moral01"
    },
    {
      "index": "27",
      "title": "老子道德三百问（第二季）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/laozi.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "50",
      "duration": "13",
      "totalDuration": "650",
      "mediaType": "高清",
      "license": "（冀）动审字[2014]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "该片讲述了李耳(后人尊称其为老子)从幼年时期开始，天资颖慧，在李母与开蒙老师商容的谆谆善诱下，与小智、小石、小月等三个小伙伴相濡以沫，一同求知问学的故事。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "moral02"
    },
    // {
    //   "index": "28",
    //   "title": "精灵爱牙讲堂之口腔健康知识",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/teeth.webp",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "动画片",
    //   "setNum": "20",
    //   "duration": "4",
    //   "totalDuration": "80",
    //   "mediaType": "高清",
    //   "license": "（鄂）动审字[2015]第003号",
    //   "lang": "中文",
    //   "region": "大陆",
    //   "actor": "牙牙精灵",
    //   "classify": "科普",
    //   "years": "未知",
    //   "director": "未知",
    //   "intro": "影片以人的牙齿为原型，设计主角牙牙精灵。通过讲述牙牙精灵跟随武大口腔医院牙博士接诊患者、参加口腔知识社区等故事，向广大观众宣传专业的口腔健康知识，以此提醒广大消费者增强口腔健康保护意识。",
    //   "latest": "",
    //   "ranking": "",
    //   "hot": "是",
    //   "original": "是",
    //   "video": "Health"
    // },
    {
      "index": "29",
      "title": "牙牙精灵战队",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/teeth2.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "20",
      "duration": "7",
      "totalDuration": "140",
      "mediaType": "高清",
      "license": "（鄂）动审字[2019]第003号",
      "lang": "中文",
      "region": "大陆",
      "actor": "牙牙队长  美牙牙  壮牙牙等",
      "classify": "科普",
      "years": "未知",
      "director": "未知",
      "intro": "本动画以牙牙精灵队长为主角，其成立的牙牙精灵战队中4个功能及性格各异的队员让剧情更加饱满。摒弃传统的科普演绎形式，把所有牙病拟人卡通化，变成一个个有性格有破坏技能的病菌怪，通过病菌们搞破坏的演绎，阐释清楚各类口腔疾病的根源。其幽默风趣的表演，将变繁冗为简单,打破口腔病理上的理解障碍，革新晦涩文字带来的沉闷。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "teeth",
    },
    {
      "index": "30",
      "title": "玩个玩具之芭比的大房子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.47",
      "totalDuration": "5.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "house2"
    },
    {
      "index": "31",
      "title": "玩个玩具之一只神奇的兔子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.17",
      "totalDuration": "5.17",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "rabbit"
    },
    {
      "index": "32",
      "title": "玩个玩具之拯救企鹅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.47",
      "totalDuration": "6.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "penguin"
    },
    {
      "index": "33",
      "title": "玩个玩具之抓住那个捣蛋鬼",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.19",
      "totalDuration": "5.19",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "youngduck"
    },
    {
      "index": "34",
      "title": "玩个玩具之翻斗猴子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.23",
      "totalDuration": "6.23",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "mokey"
    },
    {
      "index": "35",
      "title": "玩个玩具之佩奇的生日礼物奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.39",
      "totalDuration": "6.39",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "strangeegg"
    },
    {
      "index": "36",
      "title": "玩个玩具之欢迎来到兔叽咖啡厅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.04",
      "totalDuration": "5.04",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "coffee"
    },
    {
      "index": "37",
      "title": "玩个玩具之疯狂动物城奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.5",
      "totalDuration": "6.5",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "eggs"
    },
    {
      "index": "38",
      "title": "玩个玩具之欢乐水族箱",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.08",
      "totalDuration": "6.08",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "vide": "waterbox"
    },
    {
      "index": "39",
      "title": "玩个玩具之迪士尼陶艺机",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "7.14",
      "totalDuration": "7.14",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "machine"
    },
    {
      "index": "40",
      "title": "玩个玩具之彩泥霓虹工坊",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.49",
      "totalDuration": "6.49",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "workshop"
    },
    {
      "index": "41",
      "title": "玩个玩具之星海湾游乐场游记",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.57",
      "totalDuration": "5.57",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "vide": "playground"
    },
    {
      "index": "42",
      "title": "探索地球村",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/earth.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "",
      "duration": "",
      "totalDuration": "299",
      "mediaType": "高清",
      "license": "（黑）动审字【2007】第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "探索地球村用生动的画面和幽默有趣的故事帮助孩子们认识这个神奇而美丽的世界，让他们了解各种千奇百怪的自然现象是如何产生的，让孩子们从小树立热爱科学、关心自然的观念，培养他们善于观察、勇于探素的良好习惯。讲述了聪明美丽的人鱼小齐、尤尤，小海龟阿乖，小海豹达达，小沙鱼大阔，螃蟹老师、鱼博士的故事",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "earthCountry"
    },
    {
      "index": "1",
      "title": "小熊优恩",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bear.jpg.webp",
      "carousel": "4",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "高清",
      "license": "（闽）动审字[2015]第019号",
      "lang": "中文",
      "region": "大陆",
      "actor": "骆妍倩 / 陈旭昇 / 乐嘉晔 / 吕佩玉 / 刘以嘉 / 王愫酥",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "一心照顾调皮孩子的“新爸爸”-阿憨；专注工作、同时也爱着孩子的“新妈妈”-莉莉；还有他们聪明顽皮，状况不断的宝贝儿子-“优恩”——他们一起为我们带来了一个关于新生家庭的奇妙故事。 没有人教过阿憨怎么养大孩子从而笑料百出的优恩。寓教于乐，这是一部超级奶爸的成长史，也是一部欢乐育儿的教科书，给大家带来快乐的感受。",
      "latest": "最新上映",
      "ranking": "1",
      "hot": "是",
      "original": "是",
      "video": "bear"
    },
    {
      "index": "2",
      "title": "卫浴也疯狂",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bath.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（苏）动审字[2015]第002号",
      "lang": "中文",
      "region": "大陆",
      "actor": " 洗脸台 /  水龙头 /  抽水马桶 /  花洒",
      "classify": "益智",
      "years": "2015",
      "director": "李竹兵",
      "intro": "平淡无趣的卫生间里迎来了一群疯狂可爱的新伙伴，他们是洗脸台、水龙头、抽水马桶、花洒以及淋浴房。在这个看似普通的卫浴间里，每当主人不在或是夜幕降临的时候，这里就会呈现出另一番景象。 生活在这里的卫浴们被赋予了生命，面对麻烦制造者 “病菌拉吉”和沙皮狗“乌眼青”的破坏行动，卫浴们与捣蛋分子斗智斗勇，在嬉笑怒骂中打赢了一次又一次的家园保卫战",
      "latest": "最新上映",
      "ranking": "2",
      "hot": "",
      "original": "是",
      "video": "bath"
    },
    {
      "index": "3",
      "title": "功夫家族之笨笨鼠",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mouse.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "30",
      "duration": "6",
      "totalDuration": "180",
      "mediaType": "高清",
      "license": "（闽）动审字[2013]第050号",
      "lang": "中文",
      "region": "大陆",
      "actor": "笨笨鼠 / 反斗熊 / 爱心兔 / 一米熊",
      "classify": "益智",
      "years": "2013",
      "director": "李竹兵",
      "intro": "功夫村里住着笨笨鼠、反斗熊、爱心兔、一米熊四个好朋友。笨笨鼠是个大智若愚的乐天派，不管世界怎样，即使把事情搞砸也能自得其乐。反斗熊是个有着大力气但头脑简单的家伙，笨笨鼠最“亲密”的朋友，只要有笨笨鼠的地方总会有他的身影，两人在一起总能闹出一些让人发笑的故事，当然最后常常是看似弱小的笨笨鼠获得胜利。爱心兔是个爱幻想爱撒娇喜欢一切粉红事物的小女生，也是笨笨鼠和反斗熊抢着帮助的对象。一米熊是只不够自信又渴望强大的小熊，思维简单但心地善良，但也常常好心办坏事。四个性格不同的朋友在一起看似打打闹闹，但其实谁也离不开谁，内心里都把彼此当做不可缺的朋友，为紧张和压力下的现代观众带来了一幕幕源于生活的欢乐故事",
      "latest": "最新上映",
      "ranking": "3",
      "hot": "是",
      "original": "是",
      "video": "mouse"
    },
    {
      "index": "4",
      "title": "卡西龙之寻龙记",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/dragons.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2012]第018号",
      "lang": "中文",
      "region": "大陆",
      "actor": "阿尔 / 小玮 / 琳达 / 金金 / 威威 / 西西",
      "classify": "科幻",
      "years": "2012",
      "director": "李竹兵",
      "intro": "太阳系中有一个神秘的龙族，是维护宇宙正义的战族，他们在最危急的时刻会出现在需要的星系，而战龙的养成绝非偶然，必须组成团队家族，而按各属性安排在不同的行星诞生成长感受正义与力量",
      "latest": "最新上映",
      "ranking": "4",
      "hot": "",
      "original": "是",
      "video": "dragon"
    },
    {
      "index": "5",
      "title": "蔡六",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/six.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "24",
      "duration": "5",
      "totalDuration": "120",
      "mediaType": "标清",
      "license": "（闽）动审字[2011]第021号",
      "lang": "中文",
      "region": "大陆",
      "actor": "蔡六",
      "classify": "益智",
      "years": "未知",
      "director": "未知",
      "intro": "有个人叫蔡六，他非常喜欢恶作剧、捉弄人，但他恶作剧对象主要为吝啬地主、不法商人、贪官污吏等。如蔡六看到老百姓买水缸被欺负，用计让商贩尝尽苦头，替老百姓出了口恶气",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "six"
    },
    {
      "index": "6",
      "title": "石头娃",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/stone.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "13",
      "totalDuration": "338",
      "mediaType": "高清",
      "license": "（苏）动审字[2018]第009号",
      "lang": "中文",
      "region": "大陆",
      "actor": "地客 /  憨憨 /  雨雨 /  花花",
      "classify": "冒险",
      "years": "2019",
      "director": "张瑶",
      "intro": "以南京雨花石为动漫造型，讲述了神奇的雨花石精灵带着一个机智可爱的小学生雨雨穿越时光旅行，展现一个神奇的科幻世界：史前动植物的消失，能源的危机， 海啸、 火山的形成，大裂谷的跋涉和冰川的消融等等，雨雨最终破译“智慧之门”的密码",
      "latest": "最新上映",
      "ranking": "5",
      "hot": "",
      "original": "是",
      "video": "stone"
    },
    {
      "index": "7",
      "title": "少年张謇",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/youth.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "12",
      "totalDuration": "312",
      "mediaType": "高清",
      "license": "（苏）动审字[2017]第017号",
      "lang": "中文",
      "region": "大陆",
      "actor": "罗玉婷 / 蒋可 / 王燕华 / 胡谦 / 李晔",
      "classify": "",
      "years": "",
      "director": "娄朋庆",
      "intro": "张謇是聪明机智、敢于创新、忧国忧民的孩子，这些品质促使后来的张謇做出创办学校、兴修公共设施等伟大的事情，成为影响中国近代历史的重要角色。这是一部以清末状元张謇的少儿时期生活为主要内容的历史题材动画片。通过动画这种幽默、夸张的艺术形式，表现少儿时期的张謇身上所具备的独特性格品质。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "youth"
    },
    // {
    //   "index": "8",
    //   "title": "嘟嘟镇",
    //   "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/city.jpeg",
    //   "carousel": "",
    //   "country": "中国",
    //   "type": "益智",
    //   "setNum": "52",
    //   "duration": "13",
    //   "totalDuration": "676",
    //   "mediaType": "高清",
    //   "license": "（浙）动审字【2016】035号",
    //   "lang": "",
    //   "region": "",
    //   "actor": "顾烨",
    //   "classify": "亲子、教育",
    //   "years": "2016",
    //   "director": "应勋",
    //   "intro": "故事讲述了刚到嘟嘟镇工作的快递员阿卡，突然被卷入一场盗窃案中，被误会成小偷，上演了一场闹剧。后来误会化解，阿卡也在这场事件中渐渐熟悉了小镇上每位成员，他也靠着勤奋、热心与诚实获得了大家的认可。之后，整个小镇围绕着阿卡上演起一幕幕或幽默、或紧张、或温情的小故事，通过剧情传达爱与关怀的人文精神，教育小朋友友爱互助，关心社会与环境，拥抱梦想并热爱生活",
    //   "latest": "最新上映",
    //   "ranking": "6",
    //   "hot": "",
    //   "original": "是",
    //   "video": "cities"
    // },
    {
      "index": "9",
      "title": "百越历险记之壮锦密码",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/heros.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "12",
      "totalDuration": "156",
      "mediaType": "高清",
      "license": "（桂）动审字[2017]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "刘三姐 / 小昭 / 猴小白 / 卡索 / 呱呱国师",
      "classify": "其他",
      "years": "2017",
      "director": "卢军",
      "intro": "万年前，祖洛神和天仙灵珊与魔王决战于米洛仙山岜赤山顶，最终大败魔王并用12圣器将魔界与人间的通道封印，天仙灵珊舍身取义壮烈牺牲。为防万年后“七星连珠”之际魔界再次为祸人间，祖洛神留下12圣器分藏于百越大地，并派米洛王族世代镇守岜赤山。天仙灵珊在封印魔界时功力耗尽，万年之后转世人间，只有她才能运用十二圣器，用她的歌声把铜鼓等12圣器组合成天音法阵，才能彻底封印魔王，而这个人就是米洛王的三公主婉馨，她在壮王的指引下，解开了壮锦的秘密，按照壮锦地图的指引完成任务。",
      "latest": "最新上映",
      "ranking": "7",
      "hot": "",
      "original": "是",
      "video": "code"
    },
    {
      "index": "10",
      "title": "铜鼓奇缘",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/drum.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "14",
      "duration": "11",
      "totalDuration": "154",
      "mediaType": "高清",
      "license": "（桂）动审字[2019]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "刘婉馨 / 唐筱米 / 猴小白 / 武石甲 / 穆莱尔 / 高拉·索朗弓",
      "classify": "神话",
      "years": "2019",
      "director": "李尚玻",
      "intro": "\"塞壬来源自古老的希腊神话传说，在神话中的她被塑造成一名人面鸟身的海妖，飞翔在大海上，拥有天籁般的歌喉，常用歌声诱惑过路的航海者而使航船触礁沉没，船员则成为塞壬的腹中餐。别有用心的塞壬高科技公司，受传说的海上女妖故事启发，开展魔音计划，在东南亚的无人岛上建设了TEM高频声波传输发射塔，从世界各地选出歌声与魔音高度匹配的歌手，用高科技系统把歌手魔化，再利用发射塔把魔音声波发射到海上丝绸之路航线上，欲以此手段控制船员实现海盗计划。 ",
      "latest": "",
      "ranking": "8",
      "hot": "",
      "original": "是",
      "video": "drum"
    },
    {
      "index": "11",
      "title": "瓷都传奇之牛牛和妞妞",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/legend.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "12",
      "totalDuration": "312",
      "mediaType": "高清",
      "license": "（闽）动审字[2016]第008号",
      "lang": "中文",
      "region": "大陆",
      "actor": "王亚琳 / 叶方 / 王辛 / 唐泽宗 / 王雪沁 / 丁妍",
      "classify": "神话",
      "years": "2017",
      "director": "徐辉",
      "intro": "牛牛和妞妞来到瓷都德化，遇到正苦恼于改进瓷窑的窑神林炳。受牛牛和妞妞的启发，林炳成功建成龙窑，提高了瓷器的产量。大盗烮震在远洋大船海南一号建成之际，偷走了龙窑里的凌火瓷珠，瓷器的生产受阻。经过努力，赶走了大盗，还帮助改进制瓷工艺。",
      "latest": "",
      "ranking": "9",
      "hot": "",
      "original": "是",
      "video": "legend1"
    },
    {
      "index": "12",
      "title": "土楼探险之牛牛和妞妞",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/legend2.jpg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "14",
      "totalDuration": "364",
      "mediaType": "标清",
      "license": "（闽）动审字[2013]第017号",
      "lang": "中文",
      "region": "大陆",
      "actor": "付洁 /  马奇 /  张继伟 /  周正",
      "classify": "神话",
      "years": "2013",
      "director": "徐辉",
      "intro": "牛牛和妞妞与织女在鹊桥相会，淘气的妞妞失足落入人间。为了找回妹妹，牛牛在太白金星的指引下，来到永定的土楼中找到了妞妞，但牛牛发现妹妹失忆了，妹妹身上拥有守护神力祥云也不见了。邪恶的夜魔及其手下老鼠夺走了祥云。牛牛在土楼朋友们的帮助下，使妞妞恢复了记忆，并最终战胜夜魔。",
      "latest": "",
      "ranking": "10",
      "hot": "是",
      "original": "是",
      "video": "house"
    },
    {
      "index": "13",
      "title": "哈喽！葡星人",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/star1.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "15",
      "totalDuration": "390",
      "mediaType": "高清",
      "license": "（沪）动审字[2016]第013号",
      "lang": "中文",
      "region": "大陆",
      "actor": "塔塔 /  侯烨 /  裘莎莎 /  朱志摩",
      "classify": "益智",
      "years": "2016",
      "director": "刘思蜀",
      "intro": "外星人塔塔携宠物小Q与超越人类科技千年的高科技来到了地球。本以为能无往不利，结果一场意外，飞船报废，只好赖在地球男孩侯烨。侯烨平凡无奇的暑假彻底被颠覆，这个意外闯入的外星室友一边给他带来种种意想不到的麻烦，一边让侯烨见识到自己从未想象过的神奇科技：来自遥远光年外的葡星文明，千变万化的神秘探索器，眼前这个充满秘密的外星朋友。",
      "latest": "",
      "ranking": "11",
      "hot": "",
      "original": "是",
      "video": "star"
    },
    {
      "index": "14",
      "title": "哈喽！葡星人之极训特工",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/star2.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "15",
      "totalDuration": "390",
      "mediaType": "高清",
      "license": "（沪）动审字[2018]第001号",
      "lang": "中文",
      "region": "大陆",
      "actor": "塔塔 /  侯烨 /  朱志摩 /  裘莎莎",
      "classify": "益智",
      "years": "2018",
      "director": "未知",
      "intro": "关于外星学霸塔塔来地球完成毕业报告时，因飞船意外报废，结识了地球少年侯烨。从此侯烨平凡无奇的暑假彻底被颠覆，在经历了一连串鸡飞狗跳的事件后，几个孩子从相互敌对，到成为朋友；从自我中心，到学会分享；从叛逆敷衍，到承担责任",
      "latest": "",
      "ranking": "12",
      "hot": "",
      "original": "是",
      "video": "star2"
    },
    {
      "index": "15",
      "title": "阿古顿巴",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/history.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "10",
      "totalDuration": "260",
      "mediaType": "高清",
      "license": "（藏）动审字【2017】第 01 号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2020",
      "director": "未知",
      "intro": "在雪域高原的山南地区有一个平凡的小村子，村里人世世代代、按部就班地过着平凡的日子，地主收租，农户种田，牧民放牧，卖杂货的走街串巷，村口还有一个小茶馆。突然有一天，不知从哪里来了一个四处流浪的人——阿古顿巴，打破了村民们平静的生活，故事就从这里开始了",
      "latest": "",
      "ranking": "13",
      "hot": "",
      "original": "是",
      "video": "bus1"
    },
    {
      "index": "16",
      "title": "阿古顿巴  第二季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/history2.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "10",
      "totalDuration": "260",
      "mediaType": "高清",
      "license": "（藏）动审字【2018】第 1 号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2020",
      "director": "未知",
      "intro": "在雪域高原的山南地区有一个平凡的小村子，村里人世世代代、按部就班地过着平凡的日子，地主收租，农户种田，牧民放牧，卖杂货的走街串巷，村口还有一个小茶馆。突然有一天，不知从哪里来了一个四处流浪的人——阿古顿巴，打破了村民们平静的生活，故事就从这里开始了。",
      "latest": "",
      "ranking": "14",
      "hot": "",
      "original": "是",
      "video": "bus2"
    },
    {
      "index": "17",
      "title": "魔能圣甲：守护者",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/protected.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "26",
      "duration": "8",
      "totalDuration": "208",
      "mediaType": "1920*1080",
      "license": "（粤）动审字【2019】第014号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "科幻",
      "years": "未知",
      "director": "未知",
      "intro": "由于地球资源枯竭,人类面临着严重的死亡威胁,地球即将走向灭亡。科学家推出“立方计划(HEXA)”,旨在于太空中寻找一个人类宜居星球",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "protected"
    },
    {
      "index": "18",
      "title": "么么侠 第一季",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/hero.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "13",
      "duration": "13.5",
      "totalDuration": "175.5",
      "mediaType": "1920*1080",
      "license": "（苏）动审字【2022】第005号",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "科幻",
      "years": "2020",
      "director": "未知",
      "intro": "在深邃的宇宙中，有一颗美丽的绿色星球——雷普星，在雷普星上，植被遍地，生态和谐，人们安居乐业。雷普星外，有一颗小卫星么么星，雷普星的守护者初代么么侠就住在这里，远远的守望着雷普星和上面的人们。 几百年前，来自宇宙深处的破坏者——混沌王发现了雷普星，他打算把雷普星变成生命灭绝，岩浆横流的死星。为了保护雷普星，初代么么侠和污污大王展开了一场殊死决战。",
      "latest": "最新上映",
      "ranking": "15",
      "hot": "",
      "original": "是",
      "video": "hero"
    },
    {
      "index": "1",
      "title": "熊猫博士",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda1.jpeg",
      "carousel": "5",
      "country": "中国",
      "type": "动画片",
      "setNum": "39",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "最新上映",
      "ranking": "16",
      "hot": "是",
      "original": "是",
      "video": "docotor"
    },
    {
      "index": "2",
      "title": "熊猫博士和拖拖（二）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda2.jpg.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "最新上映",
      "ranking": "17",
      "hot": "是",
      "original": "是",
      "video": "video2"
    },
    {
      "index": "3",
      "title": "熊猫博士和拖拖（三）",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda3.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "最新上映",
      "ranking": "18",
      "hot": "是",
      "original": "是",
      "video": "video3"
    },
    {
      "index": "4",
      "title": "熊猫博士和拖拖第一季英文版",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda4.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "50",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "最新上映",
      "ranking": "19",
      "hot": "是",
      "original": "是",
      "video": "video4"
    },
    {
      "index": "5",
      "title": "熊猫博士和拖拖第二季英文版",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda4.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "",
      "ranking": "20",
      "hot": "是",
      "original": "是",
      "video": "video5"
    },
    {
      "index": "6",
      "title": "熊猫博士和拖拖第三季英文版",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda5.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "40",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "",
      "ranking": "21",
      "hot": "是",
      "original": "是",
      "video": "video6"
    },
    {
      "index": "7",
      "title": "熊猫博士看世界：安全消防课",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda6.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "3",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "",
      "ranking": "22",
      "hot": "是",
      "original": "是",
      "video": "video7"
    },
    {
      "index": "8",
      "title": "熊猫博士看世界：垃圾分类总动员",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda7.webp",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "2",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "",
      "ranking": "23",
      "hot": "是",
      "original": "是",
      "video": "video8"
    },
    {
      "index": "9",
      "title": "熊猫博士看世界：汽车的小秘密",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda8.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "",
      "ranking": "24",
      "hot": "是",
      "original": "是",
      "video": "video9"
    },
    {
      "index": "10",
      "title": "熊猫博士看世界：新冠肺炎全科普",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/panda9.jpeg",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "4",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "",
      "region": "大陆",
      "actor": "未知",
      "classify": "科普",
      "years": "2019",
      "director": "",
      "intro": "在熊猫城这个温馨舒适的社区里，每天的生活都充满着惊喜和意想不到的工作任务。幸运的是，我们精力充沛的熊猫博士总能伸出援手。通过帮助他的朋友们及服务社区大家庭，熊猫博士每天都能在新的职业或任务中找到乐趣。由于他充满好奇，喜欢寻找乐趣，熊猫博士总能将每一个新的挑战变成自己和他的动物朋友们的一场冒险。",
      "latest": "",
      "ranking": "25",
      "hot": "是",
      "original": "是",
      "video": "video10"
    },
    {
      "title": "摩比传说",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mobi-legend.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "32",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2013",
      "director": "",
      "intro": "《摩比传说》目前已在好未来全国各个分校推广，为孩子的课间生活增加了很多乐趣，而动画片中的人物也被广泛置入好未来的课件和文具中，生动可爱的卡通形象深受孩子的喜爱",
      "video": "legend"
    }
  ],
  videoType: [
    {
      "index": "30",
      "title": "玩个玩具之芭比的大房子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.47",
      "totalDuration": "5.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "house2"
    },
    {
      "index": "31",
      "title": "玩个玩具之一只神奇的兔子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.17",
      "totalDuration": "5.17",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "rabbit"
    },
    {
      "index": "32",
      "title": "玩个玩具之拯救企鹅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.47",
      "totalDuration": "6.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "penguin"
    },
    {
      "index": "33",
      "title": "玩个玩具之抓住那个捣蛋鬼",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.19",
      "totalDuration": "5.19",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "youngduck"
    },
    {
      "index": "34",
      "title": "玩个玩具之翻斗猴子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.23",
      "totalDuration": "6.23",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "mokey"
    },
    {
      "index": "35",
      "title": "玩个玩具之佩奇的生日礼物奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.39",
      "totalDuration": "6.39",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "strangeegg"
    },
    {
      "index": "36",
      "title": "玩个玩具之欢迎来到兔叽咖啡厅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.04",
      "totalDuration": "5.04",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "coffee"
    },
    {
      "index": "37",
      "title": "玩个玩具之疯狂动物城奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.5",
      "totalDuration": "6.5",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "eggs"
    },
    {
      "index": "38",
      "title": "玩个玩具之欢乐水族箱",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.08",
      "totalDuration": "6.08",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "vide": "waterbox"
    },
    {
      "index": "39",
      "title": "玩个玩具之迪士尼陶艺机",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "7.14",
      "totalDuration": "7.14",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "machine"
    },
    {
      "index": "40",
      "title": "玩个玩具之彩泥霓虹工坊",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.49",
      "totalDuration": "6.49",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "video": "workshop"
    },
    {
      "index": "30",
      "title": "玩个玩具之芭比的大房子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.47",
      "totalDuration": "5.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "house2"
    },
    {
      "index": "31",
      "title": "玩个玩具之一只神奇的兔子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.17",
      "totalDuration": "5.17",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "rabbit"
    },
    {
      "index": "32",
      "title": "玩个玩具之拯救企鹅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.47",
      "totalDuration": "6.47",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "penguin"
    },
    {
      "index": "33",
      "title": "玩个玩具之抓住那个捣蛋鬼",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.19",
      "totalDuration": "5.19",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "youngduck"
    },
    {
      "index": "34",
      "title": "玩个玩具之翻斗猴子",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.23",
      "totalDuration": "6.23",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "mokey"
    },
    {
      "index": "35",
      "title": "玩个玩具之佩奇的生日礼物奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.39",
      "totalDuration": "6.39",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "strangeegg"
    },
    {
      "index": "36",
      "title": "玩个玩具之欢迎来到兔叽咖啡厅",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.04",
      "totalDuration": "5.04",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "coffee"
    },
    {
      "index": "37",
      "title": "玩个玩具之疯狂动物城奇趣蛋",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.5",
      "totalDuration": "6.5",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "eggs"
    },
    {
      "index": "38",
      "title": "玩个玩具之欢乐水族箱",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.08",
      "totalDuration": "6.08",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "vide": "waterbox"
    },
    {
      "index": "39",
      "title": "玩个玩具之迪士尼陶艺机",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "7.14",
      "totalDuration": "7.14",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "machine"
    },
    {
      "index": "40",
      "title": "玩个玩具之彩泥霓虹工坊",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "6.49",
      "totalDuration": "6.49",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "video": "workshop"
    },
    {
      "index": "41",
      "title": "玩个玩具之星海湾游乐场游记",
      "img": "",
      "carousel": "",
      "country": "中国",
      "type": "动画片",
      "setNum": "1",
      "duration": "5.57",
      "totalDuration": "5.57",
      "mediaType": "高清",
      "license": "重庆市网络视听节目备案号：2207184220304002",
      "lang": "中文",
      "region": "大陆",
      "actor": "娜娜姐姐,宇舒妹妹,佳宜妹妹,王一哥哥",
      "classify": "教育",
      "years": "未知",
      "director": "未知",
      "intro": "《玩个玩具》是一档轻松活泼、寓教于乐的玩具视频类节目，充满童趣的表演，丰富有趣新奇的玩具，创意无限的剧情设计，让孩子收获开心快乐的同时，提高孩子的动手能力。",
      "latest": "",
      "ranking": "",
      "hot": "",
      "original": "是",
      "vide": "playground"
    },
    {
      "title": "摩比传说",
      "img": "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/mobi-legend.jpg",
      "country": "中国",
      "type": "动画片",
      "setNum": "32",
      "duration": "",
      "totalDuration": "",
      "mediaType": "",
      "license": "",
      "lang": "中文",
      "region": "大陆",
      "actor": "未知",
      "classify": "益智",
      "years": "2013",
      "director": "",
      "intro": "《摩比传说》目前已在好未来全国各个分校推广，为孩子的课间生活增加了很多乐趣，而动画片中的人物也被广泛置入好未来的课件和文具中，生动可爱的卡通形象深受孩子的喜爱",
      "video": "legend"
    }
  ]
}
